(function() {
	'use strict';

	var _WINDOW = {};
	var _DOCUMENT = {};

	try {
		if ( typeof window !== 'undefined' ) _WINDOW = window;
		if ( typeof document !== 'undefined' ) _DOCUMENT = document;
	} catch ( e ) {
	}

	var _ref = _WINDOW.navigator || {},
		_ref$userAgent = _ref.userAgent,
		userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

	var WINDOW = _WINDOW;
	var DOCUMENT = _DOCUMENT;
	var IS_BROWSER = !!WINDOW.document;
	var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
	var IS_IE = ~userAgent.indexOf( 'MSIE' ) || ~userAgent.indexOf( 'Trident/' );

	var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
	var PRODUCTION = function() {
		try {
			return "production" === 'production';
		} catch ( e ) {
			return false;
		}
	}();

	function bunker( fn ) {
		try {
			fn();
		} catch ( e ) {
			if ( !PRODUCTION ) {
				throw e;
			}
		}
	}

	function _defineProperty( obj, key, value ) {
		if ( key in obj ) {
			Object.defineProperty( obj, key, {
				value: value,
				enumerable: true,
				configurable: true,
				writable: true,
			} );
		} else {
			obj[ key ] = value;
		}

		return obj;
	}

	function _objectSpread( target ) {
		for ( var i = 1; i < arguments.length; i++ ) {
			var source = arguments[ i ] != null ? arguments[ i ] : {};
			var ownKeys = Object.keys( source );

			if ( typeof Object.getOwnPropertySymbols === 'function' ) {
				ownKeys = ownKeys.concat( Object.getOwnPropertySymbols( source ).filter( function( sym ) {
					return Object.getOwnPropertyDescriptor( source, sym ).enumerable;
				} ) );
			}

			ownKeys.forEach( function( key ) {
				_defineProperty( target, key, source[ key ] );
			} );
		}

		return target;
	}

	var w = WINDOW || {};
	if ( !w[ NAMESPACE_IDENTIFIER ] ) w[ NAMESPACE_IDENTIFIER ] = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].styles ) w[ NAMESPACE_IDENTIFIER ].styles = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].hooks ) w[ NAMESPACE_IDENTIFIER ].hooks = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].shims ) w[ NAMESPACE_IDENTIFIER ].shims = [];
	var namespace = w[ NAMESPACE_IDENTIFIER ];

	function define( prefix, icons ) {
		var normalized = Object.keys( icons ).reduce( function( acc, iconName ) {
			var icon = icons[ iconName ];
			var expanded = !!icon.icon;

			if ( expanded ) {
				acc[ icon.iconName ] = icon.icon;
			} else {
				acc[ iconName ] = icon;
			}

			return acc;
		}, {} );

		if ( typeof namespace.hooks.addPack === 'function' ) {
			namespace.hooks.addPack( prefix, normalized );
		} else {
			namespace.styles[ prefix ] = _objectSpread( {}, namespace.styles[ prefix ] || {}, normalized );
		}
		/**
		 * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
		 * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
		 * for `fas` so we'll easy the upgrade process for our users by automatically defining
		 * this as well.
		 */


		if ( prefix === 'fas' ) {
			define( 'fa', icons );
		}
	}

	var icons = {
		"facebook-f": [320, 512, [], "f39e", "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"],
		"instagram": [448, 512, [], "f16d", "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"],
		"linkedin-in": [448, 512, [], "f0e1", "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"],
		"youtube": [576, 512, [], "f167", "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"],
		"youtube-square": [448, 512, [], "f431", "M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"],
		"twitter": [512, 512, [], "f099", "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"],
		"odontia-arrow-right": [154, 512, [], "e902", "M125.8,138.2L1.9,0L0,97.9L137.1,256C166.5,209.9,156.2,172.2,125.8,138.2z M0,414.1L1.9,512l123.5-138.2c30.4-34,40.7-72.2,11.2-117.8L0,414.1z"],
		"odontia-times": [512, 512, [], "e903", "M 278.5,233.3 V 0.3 h -46 v 233 h -233 v 46 h 233 v 233 h 46 v -233 h 233 v -46 z"],
		"odontia-alt-arrow-right": [512, 512, [], "e904", "M504.4,239L349.2,83.9c-9.5-9.5-25-9.5-34.5,0c-9.5,9.5-9.5,25,0,34.5l113.5,113.5H-0.5v48.8h428.8L314.8,394.2 c-9.5,9.5-9.5,25,0,34.5c9.5,9.5,25,9.5,34.5,0l155.2-155.2C513.9,264,513.9,248.6,504.4,239z"],
		"odontia-lock": [512, 512, [], "e905", "M354.1,209.2v-70.6c0-37.2-15.7-72.6-43.3-98.5C283.4,14.3,246.4,0,208.2,0c-38.3,0-75.2,14.3-102.7,40.1C78,66,62.2,101.4,62.2,138.6v70.6H0V512h416.3V209.2H354.1z M108.1,138.6c0-24.1,10.2-47.6,28.8-65.1c18.7-17.6,44.3-27.6,71.3-27.6c27,0,52.6,10.1,71.3,27.6c18.6,17.5,28.8,40.9,28.8,65.1v70.6H108.1V138.6z M370.5,466.1H45.9v-211h324.6V466.1z"],
		"odontia-close": [512, 512, [], "e906", "M256,512C114.8,512,0,397.2,0,256S114.8,0,256,0s256,114.8,256,256S397.2,512,256,512z M256,29.3 C131,29.3,29.3,131,29.3,256S131,482.7,256,482.7S482.7,381,482.7,256S381,29.3,256,29.3z M383.9,281.1H119.7v-58.5h264.3V281.1z"],
		"odontia-phone": [359, 512, [], "e907", "M55.3,28.2L115.9,0l86.2,168.3L144,196.9c-11.5,26.9,46.1,134.2,70.3,135.9c1.9-1.2,57-28.3,57-28.3L359,473.7c0,0-59,28.9-60.9,29.8C130.4,580.1-109.4,114,55.3,28.2z M96.4,55.4L74.6,66.1c-112.9,58.9,89.1,451.9,205.8,398.6l20.7-10.1l-48.4-93.5l-21.9,10.7c-67.5,33-176.3-175.3-107.8-212l21.5-10.6L96.4,55.4z"],
		"odontia-email": [512, 348, [], "e908", "M16,0C7.2,0,0,7.2,0,16v352c0,8.8,7.2,16,16,16h480c8.8,0,16-7.2,16-16V16c0-8.8-7.2-16-16-16H16z M459,42.7L256,207.2L52.9,42.7H459z M42.7,341.3V89.2L256,262.1L469.3,89.2v252.1H42.7z"],
		"odontia-marker": [426.7, 512, [], "e909", "M213.4,512c-4.2,0-8.3-1.2-11.9-3.6C193.2,502.9,0,372.3,0,213.4c0-57,22.2-110.6,62.5-150.9S156.4,0,213.4,0S324,22.2,364.3,62.5s62.5,93.9,62.5,150.9c0,158.9-193.2,289.5-201.4,295C221.7,510.8,217.5,512,213.4,512z M213.4,43c-45.5,0-88.3,17.7-120.5,49.9C60.7,125.1,43,167.9,43,213.4C43,328.6,172.8,434,213.4,464.1c40.6-30.1,170.4-135.5,170.4-250.7c0-45.5-17.7-88.3-49.9-120.5C301.7,60.7,258.9,43,213.4,43z M213.3,298.8c-47.1,0-85.5-38.3-85.5-85.5s38.3-85.5,85.5-85.5c47.1,0,85.5,38.3,85.5,85.5S260.4,298.8,213.3,298.8z M213.3,170.9c-23.4,0-42.5,19.1-42.5,42.5s19.1,42.5,42.5,42.5s42.5-19.1,42.5-42.5S236.7,170.9,213.3,170.9z"],
		"odontia-angle-right": [281.6, 512, [], "e910", "M0,475.7L219.7,256L0,36.3L36.3,0l237.9,237.9c10,10,10,26.2,0,36.3L36.3,512L0,475.7z"],
		"odontia-sound-on": [512, 512, [], "e905", "M256,0C114.8,0,0,114.8,0,256c0,141.2,114.8,256,256,256c141.2,0,256-114.8,256-256C512,114.8,397.2,0,256,0z M256,486.4C129,486.4,25.6,383,25.6,256C25.6,129,129,25.6,256,25.6C383,25.6,486.4,129,486.4,256C486.4,383,383,486.4,256,486.4z M235.9,154.9c-4.4-2.1-9.7-1.5-13.5,1.5l-60.5,48.4h-46.7c-7.1,0-12.8,5.7-12.8,12.8v76.8c0,7.1,5.7,12.8,12.8,12.8h46.7l60.5,48.4c2.3,1.9,5.1,2.8,8,2.8c1.9,0,3.8-0.4,5.5-1.3c4.4-2.1,7.3-6.6,7.3-11.5V166.4C243.2,161.5,240.4,157,235.9,154.9z M217.6,319l-43.2-34.6c-2.3-1.8-5.1-2.8-8-2.8H128v-51.2h38.4c2.9,0,5.7-1,8-2.8l43.2-34.6V319z M297.6,201.6c14.5,14.5,22.5,33.8,22.5,54.3c0,20.5-8,39.8-22.5,54.3c-2.5,2.5-5.8,3.8-9,3.8c-3.3,0-6.6-1.2-9.1-3.8c-5-5-5-13.1,0-18.1c9.7-9.7,15-22.5,15-36.2c0-13.7-5.3-26.5-15-36.2c-5-5-5-13.1,0-18.1S292.6,196.6,297.6,201.6z M342.8,156.4C369.3,183,384,218.4,384,256c0,37.6-14.6,73-41.2,99.5c-2.5,2.5-5.8,3.8-9,3.8c-3.3,0-6.6-1.2-9.1-3.8c-5-5-5-13.1,0-18.1c21.8-21.8,33.7-50.7,33.7-81.5c0-30.8-12-59.7-33.7-81.4c-5-5-5-13.1,0-18.1C329.6,151.4,337.8,151.4,342.8,156.4z"],
		"odontia-sound-off": [512, 512, [], "e906", "M235.9,154.9c-4.4-2.1-9.7-1.5-13.5,1.5l-60.5,48.4h-46.7c-7.1,0-12.8,5.7-12.8,12.8v76.8c0,7.1,5.7,12.8,12.8,12.8h46.7l60.5,48.4c2.3,1.9,5.1,2.8,8,2.8c1.9,0,3.8-0.4,5.5-1.3c4.4-2.1,7.3-6.6,7.3-11.5V166.4C243.2,161.5,240.4,157,235.9,154.9z M217.6,319l-43.2-34.6c-2.3-1.8-5.1-2.8-8-2.8H128v-51.2h38.4c2.9,0,5.7-1,8-2.8l43.2-34.6V319z M256,0C114.8,0,0,114.8,0,256c0,141.2,114.8,256,256,256c141.2,0,256-114.8,256-256C512,114.8,397.2,0,256,0z M256,486.4C129,486.4,25.6,383,25.6,256C25.6,129,129,25.6,256,25.6C383,25.6,486.4,129,486.4,256C486.4,383,383,486.4,256,486.4z M393,226.6L363.7,256l29.3,29.4c5,5,5,13.1,0,18.1c-2.5,2.5-5.8,3.8-9,3.8s-6.5-1.2-9-3.8l-29.4-29.4l-29.4,29.4c-2.5,2.5-5.8,3.8-9,3.8c-3.3,0-6.6-1.2-9.1-3.8c-5-5-5-13.1,0-18.1l29.4-29.4l-29.4-29.4c-5-5-5-13.1,0-18.1s13.1-5,18.1,0l29.4,29.3l29.4-29.3c5-5,13.1-5,18.1,0S398,221.6,393,226.6z"],

		"odontia-parking": [512, 512, [], "e907", "M284.5,128h-92.5v244.5h41v-91.5h51.5c42.2,0,76.5-34.2,76.5-76.5s-34.2-76.5-76.5-76.5ZM284.5,240h-51.5v-71h51.5c19.6,0,35.5,15.9,35.5,35.5s-15.9,35.5-35.5,35.5ZM256,0C114.6,0,0,114.6,0,256s114.6,256,256,256,256-114.6,256-256S397.4,0,256,0ZM256,471c-118.8,0-215-96.3-215-215S137.2,41,256,41s215,96.3,215,215-96.3,215-215,215Z"],
		"odontia-shopping": [384, 512, [], "e908", "M292.5,128v-27.5C292.5,45,247.5,0,192,0s-100.5,45-100.5,100.5v27.5H0v384h384V128h-91.5ZM132.5,100.5c0-32.9,26.6-59.5,59.5-59.5s59.5,26.6,59.5,59.5v27.5h-119v-27.5ZM343,471H41V169h50.6v55h41v-55h119v55h41v-55h50.5v302.1Z"],
		"odontia-transport": [512, 512, [], "e909", "M448,64H64C28.7,64,0,92.7,0,128v192c0,35.3,28.7,64,64,64h1.6c7.4,36.5,39.7,64,78.4,64s71-27.5,78.4-64h67.2c7.4,36.5,39.7,64,78.4,64s71-27.5,78.4-64h1.6c35.3,0,64-28.7,64-64V128c0-35.3-28.7-64-64-64ZM41,128c0-12.7,10.3-23,23-23h256v87H41v-64ZM144,407c-21.6,0-39-17.5-39-39s17.5-39,39-39,39,17.5,39,39-17.5,39-39,39ZM368,407c-21.6,0-39-17.5-39-39s17.5-39,39-39,39,17.5,39,39-17.5,39-39,39ZM471,320c0,12.7-10.3,23-23,23h-4c-10.5-32-40.6-55-76-55s-65.5,23.1-76,55h-71.9c-10.5-32-40.6-55-76-55s-65.5,23.1-76,55h-4c-12.7,0-23-10.3-23-23v-87h430.1v87ZM471,192h-110.1v-87h87c12.7,0,23,10.3,23,23v64Z"],


	};

	bunker( function() {
		define( 'fab', icons );
	} );

}());
(function() {
	'use strict';

	var _WINDOW = {};
	var _DOCUMENT = {};

	try {
		if ( typeof window !== 'undefined' ) _WINDOW = window;
		if ( typeof document !== 'undefined' ) _DOCUMENT = document;
	} catch ( e ) {
	}

	var _ref = _WINDOW.navigator || {},
		_ref$userAgent = _ref.userAgent,
		userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

	var WINDOW = _WINDOW;
	var DOCUMENT = _DOCUMENT;
	var IS_BROWSER = !!WINDOW.document;
	var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
	var IS_IE = ~userAgent.indexOf( 'MSIE' ) || ~userAgent.indexOf( 'Trident/' );

	var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
	var PRODUCTION = function() {
		try {
			return "production" === 'production';
		} catch ( e ) {
			return false;
		}
	}();

	function bunker( fn ) {
		try {
			fn();
		} catch ( e ) {
			if ( !PRODUCTION ) {
				throw e;
			}
		}
	}

	function _defineProperty( obj, key, value ) {
		if ( key in obj ) {
			Object.defineProperty( obj, key, {
				value: value,
				enumerable: true,
				configurable: true,
				writable: true,
			} );
		} else {
			obj[ key ] = value;
		}

		return obj;
	}

	function _objectSpread( target ) {
		for ( var i = 1; i < arguments.length; i++ ) {
			var source = arguments[ i ] != null ? arguments[ i ] : {};
			var ownKeys = Object.keys( source );

			if ( typeof Object.getOwnPropertySymbols === 'function' ) {
				ownKeys = ownKeys.concat( Object.getOwnPropertySymbols( source ).filter( function( sym ) {
					return Object.getOwnPropertyDescriptor( source, sym ).enumerable;
				} ) );
			}

			ownKeys.forEach( function( key ) {
				_defineProperty( target, key, source[ key ] );
			} );
		}

		return target;
	}

	var w = WINDOW || {};
	if ( !w[ NAMESPACE_IDENTIFIER ] ) w[ NAMESPACE_IDENTIFIER ] = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].styles ) w[ NAMESPACE_IDENTIFIER ].styles = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].hooks ) w[ NAMESPACE_IDENTIFIER ].hooks = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].shims ) w[ NAMESPACE_IDENTIFIER ].shims = [];
	var namespace = w[ NAMESPACE_IDENTIFIER ];

	function define( prefix, icons ) {
		var normalized = Object.keys( icons ).reduce( function( acc, iconName ) {
			var icon = icons[ iconName ];
			var expanded = !!icon.icon;

			if ( expanded ) {
				acc[ icon.iconName ] = icon.icon;
			} else {
				acc[ iconName ] = icon;
			}

			return acc;
		}, {} );

		if ( typeof namespace.hooks.addPack === 'function' ) {
			namespace.hooks.addPack( prefix, normalized );
		} else {
			namespace.styles[ prefix ] = _objectSpread( {}, namespace.styles[ prefix ] || {}, normalized );
		}
		/**
		 * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
		 * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
		 * for `fas` so we'll easy the upgrade process for our users by automatically defining
		 * this as well.
		 */


		if ( prefix === 'fas' ) {
			define( 'fa', icons );
		}
	}

	var icons = {
		"search": [512, 512, [], "f002", "M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"],
		"play": [448, 512, [], "f04b", "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6zm-16.2 55.1l-352 208C45.6 483.9 32 476.6 32 464V47.9c0-16.3 16.4-18.4 24.1-13.8l352 208.1c10.5 6.2 10.5 21.4.1 27.6z"],
		"sign-out-alt": [512, 512, [], "f2f5", "M160 217.1c0-8.8 7.2-16 16-16h144v-93.9c0-7.1 8.6-10.7 13.6-5.7l141.6 143.1c6.3 6.3 6.3 16.4 0 22.7L333.6 410.4c-5 5-13.6 1.5-13.6-5.7v-93.9H176c-8.8 0-16-7.2-16-16v-77.7m-32 0v77.7c0 26.5 21.5 48 48 48h112v61.9c0 35.5 43 53.5 68.2 28.3l141.7-143c18.8-18.8 18.8-49.2 0-68L356.2 78.9c-25.1-25.1-68.2-7.3-68.2 28.3v61.9H176c-26.5 0-48 21.6-48 48zM0 112v288c0 26.5 21.5 48 48 48h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48C21.5 64 0 85.5 0 112z"],
		"sliders-h": [512, 512, [], "f1de", "M504 384H192v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h312c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-344 64h-32v-96h32v96zM504 96H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h152v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h248c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-280 64h-32V64h32v96zm280 80h-88v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h312v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-120 64h-32v-96h32v96z"],
		"sort-alpha-down": [448, 512, [], "f15d", "M416.2 207.9l-60.4-168c-1.7-4.8-6.2-7.9-11.3-7.9h-16.9c-5.1 0-9.6 3.2-11.3 7.9l-60.4 168c-2.8 7.8 3 16.1 11.3 16.1h11.3c5.1 0 9.7-3.2 11.3-8.1l15.3-44.3h61.5L382 216c1.7 4.8 6.2 8 11.3 8h11.6c8.3 0 14.1-8.2 11.3-16.1zm-101-67.3l18.1-51.2c.9-2.6 1.8-5.6 2.7-8.7.9 3.1 1.8 6.2 2.6 8.8l17.8 51.2h-41.2zM197.4 368c-4.7-4.7-12.3-4.7-17 0L129 419.9V44c0-6.6-5.4-12-12-12h-10c-6.6 0-12 5.4-12 12v375.9L43.6 368c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l84 84.5c4.7 4.7 12.3 4.7 17 0l84-84.5c4.7-4.7 4.7-12.3 0-17zm198.4 79.9h-84.1c4.8-6-1.2 2.3 92.9-133.6 1.4-2 2.1-4.4 2.1-6.8V300c0-6.6-5.4-12-12-12H280.9c-6.6 0-12 5.4-12 12v8.1c0 6.6 5.4 12 12 12h78.2c-3 3.8 4.6-7.1-92.8 133.3-1.4 2-2.1 4.4-2.1 6.8v7.8c0 6.6 5.4 12 12 12h119.5c6.6 0 12-5.4 12-12v-8.1c.1-6.6-5.3-12-11.9-12z"],
		"th": [512, 512, [], "f00a", "M0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80zm320-16v106.667H192V64h128zm160 245.333H352V202.667h128v106.666zm-160 0H192V202.667h128v106.666zM32 202.667h128v106.667H32V202.667zM160 64v106.667H32V80c0-8.837 7.163-16 16-16h112zM32 432v-90.667h128V448H48c-8.837 0-16-7.163-16-16zm160 16V341.333h128V448H192zm160 0V341.333h128V432c0 8.837-7.163 16-16 16H352zm128-277.333H352V64h112c8.837 0 16 7.163 16 16v90.667z"],
		"caret-down": [320, 512, [], "f0d7", "M287.968 160H32.038c-28.425 0-42.767 34.488-22.627 54.627l127.962 128c12.496 12.496 32.758 12.497 45.255 0l127.968-128C330.695 194.528 316.45 160 287.968 160zM160 320L32 192h256L160 320z"],
		"caret-up": [320, 512, [], "f0d8", "M32.032 352h255.93c28.425 0 42.767-34.488 22.627-54.627l-127.962-128c-12.496-12.496-32.758-12.497-45.255 0l-127.968 128C-10.695 317.472 3.55 352 32.032 352zM160 192l128 128H32l128-128z"],
		"times": [320, 512, [], "f00d", "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"],
		"laptop": [640, 512, [], "f109", "M624 368h-48V96c0-35.3-28.72-64-64-64H128c-35.28 0-64 28.7-64 64v272H16c-8.84 0-16 7.16-16 16v48c0 44.11 35.88 80 80 80h480c44.12 0 80-35.89 80-80v-48c0-8.84-7.16-16-16-16zM96 96c0-17.67 14.33-32 32-32h384c17.67 0 32 14.33 32 32v272H391.13c-4.06 0-7.02 3.13-7.92 7.09C379.98 389.35 367.23 400 352 400h-64c-15.23 0-27.98-10.65-31.21-24.91-.9-3.96-3.86-7.09-7.92-7.09H96V96zm512 336c0 26.47-21.53 48-48 48H80c-26.47 0-48-21.53-48-48v-32h194.75c6.59 18.62 24.38 32 45.25 32h96c20.88 0 38.66-13.38 45.25-32H608v32z"],
		"mobile": [320, 512, [], "f10b", "M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zM320 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-32 0c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V48z"],
		"mobile-alt": [320, 512, [], "f3cd", "M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm32-320H96v240h128V96m20-32c6.6 0 12 5.4 12 12v280c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h168zm76-16v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-32 0c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V48z"],
		"angle-double-down": [256, 512, [], "f103", "M119.5 262.9L3.5 145.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 223.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 263c-4.7 4.6-12.3 4.6-17-.1zm17 128l116-117.8c4.7-4.7 4.7-12.3 0-17l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L128 351.3 27.6 249.1c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l116 117.8c4.7 4.6 12.3 4.6 17-.1z"],
		"angle-double-left": [320, 512, [], "f100", "M153.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L192.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L153 264.5c-4.6-4.7-4.6-12.3.1-17zm-128 17l117.8 116c4.7 4.7 12.3 4.7 17 0l7.1-7.1c4.7-4.7 4.7-12.3 0-17L64.7 256l102.2-100.4c4.7-4.7 4.7-12.3 0-17l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L25 247.5c-4.6 4.7-4.6 12.3.1 17z"],
		"angle-double-right": [320, 512, [], "f101", "M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17zm128-17l-117.8-116c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17L255.3 256 153.1 356.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l117.8-116c4.6-4.7 4.6-12.3-.1-17z"],
		"angle-double-up": [256, 512, [], "f102", "M136.5 249.1l116 117.8c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L128 288.7 27.6 390.9c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l116-117.8c4.7-4.6 12.3-4.6 17 .1zm-17-128L3.5 238.9c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0L128 160.7l100.4 102.2c4.7 4.7 12.3 4.7 17 0l7.1-7.1c4.7-4.7 4.7-12.3 0-17L136.5 121c-4.7-4.6-12.3-4.6-17 .1z"],
		"angle-down": [256, 512, [], "f107", "M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"],
		"angle-left": [192, 512, [], "f104", "M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z"],
		"angle-right": [192, 512, [], "f105", "M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z"],
		"angle-up": [256, 512, [], "f106", "M136.5 185.1l116 117.8c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L128 224.7 27.6 326.9c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l116-117.8c4.7-4.6 12.3-4.6 17 .1z"],
		"download": [512, 512, [], "f019", "M452 432c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20zm-84-20c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20zm144-48v104c0 24.3-19.7 44-44 44H44c-24.3 0-44-19.7-44-44V364c0-24.3 19.7-44 44-44h99.4L87 263.6c-25.2-25.2-7.3-68.3 28.3-68.3H168V40c0-22.1 17.9-40 40-40h96c22.1 0 40 17.9 40 40v155.3h52.7c35.6 0 53.4 43.1 28.3 68.3L368.6 320H468c24.3 0 44 19.7 44 44zm-261.7 17.7c3.1 3.1 8.2 3.1 11.3 0L402.3 241c5-5 1.5-13.7-5.7-13.7H312V40c0-4.4-3.6-8-8-8h-96c-4.4 0-8 3.6-8 8v187.3h-84.7c-7.1 0-10.7 8.6-5.7 13.7l140.7 140.7zM480 364c0-6.6-5.4-12-12-12H336.6l-52.3 52.3c-15.6 15.6-41 15.6-56.6 0L175.4 352H44c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12V364z"],
		"play-circle": [512, 512, [], "f144", "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zM40 256c0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216zm331.7-18l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM192 335.8V176.9c0-4.7 5.1-7.6 9.1-5.1l134.5 81.7c3.9 2.4 3.8 8.1-.1 10.3L201 341c-4 2.3-9-.6-9-5.2z"],
		"info": [256, 512, [], "f129", "M208 368.667V208c0-15.495-7.38-29.299-18.811-38.081C210.442 152.296 224 125.701 224 96c0-52.935-43.065-96-96-96S32 43.065 32 96c0 24.564 9.274 47.004 24.504 64H56c-26.467 0-48 21.533-48 48v48c0 23.742 17.327 43.514 40 47.333v65.333C25.327 372.486 8 392.258 8 416v48c0 26.467 21.533 48 48 48h144c26.467 0 48-21.533 48-48v-48c0-23.742-17.327-43.514-40-47.333zM128 32c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zm88 432c0 8.837-7.163 16-16 16H56c-8.837 0-16-7.163-16-16v-48c0-8.837 7.163-16 16-16h24V272H56c-8.837 0-16-7.163-16-16v-48c0-8.837 7.163-16 16-16h104c8.837 0 16 7.163 16 16v192h24c8.837 0 16 7.163 16 16v48z"],
		"calendar": [448, 512, [], "f133", "M400 64h-48V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H128V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM48 96h352c8.822 0 16 7.178 16 16v48H32v-48c0-8.822 7.178-16 16-16zm352 384H48c-8.822 0-16-7.178-16-16V192h384v272c0 8.822-7.178 16-16 16z"],
		"map-marker": [384, 512, [], "f041", "M192 0C85.961 0 0 85.961 0 192c0 77.413 26.97 99.031 172.268 309.67 9.534 13.772 29.929 13.774 39.465 0C357.03 291.031 384 269.413 384 192 384 85.961 298.039 0 192 0zm0 473.931C52.705 272.488 32 256.494 32 192c0-42.738 16.643-82.917 46.863-113.137S149.262 32 192 32s82.917 16.643 113.137 46.863S352 149.262 352 192c0 64.49-20.692 80.47-160 281.931z"],
		"university": [512, 512, [], "f19c", "M496 448h-16v-40c0-13.255-10.745-24-24-24h-40V208h-32v176h-64V208h-32v176h-64V208h-32v176h-64V208H96v176H56c-13.255 0-24 10.745-24 24v40H16c-8.837 0-16 7.163-16 16v8a8 8 0 0 0 8 8h496a8 8 0 0 0 8-8v-8c0-8.837-7.163-16-16-16zM64 416h384v32H64v-32zm440.267-280L271.179 34.463a48.004 48.004 0 0 0-30.358 0L7.733 136A11.999 11.999 0 0 0 0 147.216V156c0 6.627 5.373 12 12 12h20v12c0 6.627 5.373 12 12 12h424c6.627 0 12-5.373 12-12v-12h20c6.627 0 12-5.373 12-12v-8.784c0-4.982-3.077-9.445-7.733-11.216zM448 160H64v-13.606l187.943-81.871a16.004 16.004 0 0 1 8.114 0L448 146.394V160z"],
		"external-link-square": [448, 512, [], "f14c", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm16 400c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h352c8.822 0 16 7.178 16 16v352zM99.515 374.828c-4.686-4.686-4.686-12.284 0-16.971l195.15-195.15-.707-.707-89.958.342c-6.627 0-12-5.373-12-12v-9.999c0-6.628 5.372-12 12-12L340 128c6.627 0 12 5.372 12 12l-.343 136c0 6.627-5.373 12-12 12h-9.999c-6.627 0-12-5.373-12-12l.342-89.958-.707-.707-195.15 195.15c-4.686 4.686-12.284 4.686-16.971 0l-5.657-5.657z"],
		"dot-circle": [512, 512, [], "f192", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.663 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.663 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm0-296c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80zm0 128c-26.467 0-48-21.533-48-48s21.533-48 48-48 48 21.533 48 48-21.533 48-48 48z"],
		"external-link": [576, 512, [], "f08e", "M195.515 374.828c-4.686-4.686-4.686-12.284 0-16.971l323.15-323.15-.707-.707-89.958.342c-6.627 0-12-5.373-12-12v-9.999c0-6.628 5.372-12 12-12L564 0c6.627 0 12 5.372 12 12l-.343 136c0 6.627-5.373 12-12 12h-9.999c-6.627 0-12-5.373-12-12L542 58.042l-.707-.707-323.15 323.15c-4.686 4.686-12.284 4.686-16.971 0l-5.657-5.657zm232-155.633l-8 8A12 12 0 0 0 416 235.68V464c0 8.837-7.164 16-16 16H48c-8.836 0-16-7.163-16-16V112c0-8.837 7.164-16 16-16h339.976c3.183 0 6.235-1.264 8.485-3.515l8-8c7.56-7.56 2.206-20.485-8.485-20.485H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V227.681c0-10.691-12.926-16.045-20.485-8.486z"],
		"clock": [512, 512, [], "f017", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-148.9 88.3l-81.2-59c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h14c6.6 0 12 5.4 12 12v146.3l70.5 51.3c5.4 3.9 6.5 11.4 2.6 16.8l-8.2 11.3c-3.9 5.3-11.4 6.5-16.8 2.6z"],
		"map-marker-alt": [384, 512, [], "f3c5", "M192 96c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm0-256C85.961 0 0 85.961 0 192c0 77.413 26.97 99.031 172.268 309.67 9.534 13.772 29.929 13.774 39.465 0C357.03 291.031 384 269.413 384 192 384 85.961 298.039 0 192 0zm0 473.931C52.705 272.488 32 256.494 32 192c0-42.738 16.643-82.917 46.863-113.137S149.262 32 192 32s82.917 16.643 113.137 46.863S352 149.262 352 192c0 64.49-20.692 80.47-160 281.931z"],
		"envelope": [512, 512, [], "f0e0", "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z"],
		"question": [384, 512, [], "f128", "M200.343 0C124.032 0 69.761 31.599 28.195 93.302c-14.213 21.099-9.458 49.674 10.825 65.054l42.034 31.872c20.709 15.703 50.346 12.165 66.679-8.51 21.473-27.181 28.371-31.96 46.132-31.96 10.218 0 25.289 6.999 25.289 18.242 0 25.731-109.3 20.744-109.3 122.251V304c0 16.007 7.883 30.199 19.963 38.924C109.139 360.547 96 386.766 96 416c0 52.935 43.065 96 96 96s96-43.065 96-96c0-29.234-13.139-55.453-33.817-73.076 12.08-8.726 19.963-22.917 19.963-38.924v-4.705c25.386-18.99 104.286-44.504 104.286-139.423C378.432 68.793 288.351 0 200.343 0zM192 480c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm50.146-186.406V304c0 8.837-7.163 16-16 16h-68.292c-8.836 0-16-7.163-16-16v-13.749c0-86.782 109.3-57.326 109.3-122.251 0-32-31.679-50.242-57.289-50.242-33.783 0-49.167 16.18-71.242 44.123-5.403 6.84-15.284 8.119-22.235 2.848l-42.034-31.872c-6.757-5.124-8.357-14.644-3.62-21.677C88.876 60.499 132.358 32 200.343 32c70.663 0 146.089 55.158 146.089 127.872 0 96.555-104.286 98.041-104.286 133.722z"],
		"ticket": [576, 512, [], "f145", "M544 224h32V112c0-26.51-21.49-48-48-48H48C21.49 64 0 85.49 0 112v112h32c17.673 0 32 14.327 32 32s-14.327 32-32 32H0v112c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V288h-32c-17.673 0-32-14.327-32-32s14.327-32 32-32zm0 96v80c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16v-80c35.29 0 64-28.71 64-64s-28.71-64-64-64v-80c0-8.823 7.177-16 16-16h480c8.823 0 16 7.177 16 16v80c-35.29 0-64 28.71-64 64s28.71 64 64 64z"],
		"long-arrow-right": [448, 512, [], "f178", "M311.03 131.515l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887l-83.928 83.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l116.485-116c4.686-4.686 4.686-12.284 0-16.971L328 131.515c-4.686-4.687-12.284-4.687-16.97 0z"],
		"plus": [384, 512, [], "f067", "M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"],
		"minus": [384, 512, [], "f068", "M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"],
		"star": [576, 512, [], "f005", "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM405.8 317.9l27.8 162L288 403.5 142.5 480l27.8-162L52.5 203.1l162.7-23.6L288 32l72.8 147.5 162.7 23.6-117.7 114.8z"],
		"star-half": [576, 512, [], "f089", "M288 403.4l-145.5 76.5 27.8-162L52.5 203.1l162.7-23.6L288 32V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-36.2z"],

	};

	bunker( function() {
		define( 'fal', icons );
	} );

}());
(function() {
	'use strict';

	var _WINDOW = {};
	var _DOCUMENT = {};

	try {
		if ( typeof window !== 'undefined' ) _WINDOW = window;
		if ( typeof document !== 'undefined' ) _DOCUMENT = document;
	} catch ( e ) {
	}

	var _ref = _WINDOW.navigator || {},
		_ref$userAgent = _ref.userAgent,
		userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

	var WINDOW = _WINDOW;
	var DOCUMENT = _DOCUMENT;
	var IS_BROWSER = !!WINDOW.document;
	var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
	var IS_IE = ~userAgent.indexOf( 'MSIE' ) || ~userAgent.indexOf( 'Trident/' );

	var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
	var PRODUCTION = function() {
		try {
			return "production" === 'production';
		} catch ( e ) {
			return false;
		}
	}();

	function bunker( fn ) {
		try {
			fn();
		} catch ( e ) {
			if ( !PRODUCTION ) {
				throw e;
			}
		}
	}

	function _defineProperty( obj, key, value ) {
		if ( key in obj ) {
			Object.defineProperty( obj, key, {
				value: value,
				enumerable: true,
				configurable: true,
				writable: true,
			} );
		} else {
			obj[ key ] = value;
		}

		return obj;
	}

	function _objectSpread( target ) {
		for ( var i = 1; i < arguments.length; i++ ) {
			var source = arguments[ i ] != null ? arguments[ i ] : {};
			var ownKeys = Object.keys( source );

			if ( typeof Object.getOwnPropertySymbols === 'function' ) {
				ownKeys = ownKeys.concat( Object.getOwnPropertySymbols( source ).filter( function( sym ) {
					return Object.getOwnPropertyDescriptor( source, sym ).enumerable;
				} ) );
			}

			ownKeys.forEach( function( key ) {
				_defineProperty( target, key, source[ key ] );
			} );
		}

		return target;
	}

	var w = WINDOW || {};
	if ( !w[ NAMESPACE_IDENTIFIER ] ) w[ NAMESPACE_IDENTIFIER ] = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].styles ) w[ NAMESPACE_IDENTIFIER ].styles = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].hooks ) w[ NAMESPACE_IDENTIFIER ].hooks = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].shims ) w[ NAMESPACE_IDENTIFIER ].shims = [];
	var namespace = w[ NAMESPACE_IDENTIFIER ];

	function define( prefix, icons ) {
		var normalized = Object.keys( icons ).reduce( function( acc, iconName ) {
			var icon = icons[ iconName ];
			var expanded = !!icon.icon;

			if ( expanded ) {
				acc[ icon.iconName ] = icon.icon;
			} else {
				acc[ iconName ] = icon;
			}

			return acc;
		}, {} );

		if ( typeof namespace.hooks.addPack === 'function' ) {
			namespace.hooks.addPack( prefix, normalized );
		} else {
			namespace.styles[ prefix ] = _objectSpread( {}, namespace.styles[ prefix ] || {}, normalized );
		}
		/**
		 * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
		 * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
		 * for `fas` so we'll easy the upgrade process for our users by automatically defining
		 * this as well.
		 */


		if ( prefix === 'fas' ) {
			define( 'fa', icons );
		}
	}

	var icons = {
		"search": [512, 512, [], "f002", "M505,460.4L374.8,330.3c-0.9-0.9-2.1-1.3-3.1-2.1c25.3-34.2,40.4-76.4,40.4-122.1C412.2,92.5,319.7,0,206.1,0 C92.5,0,0,92.5,0,206.1c0,113.7,92.5,206.1,206.1,206.1c51.1,0,97.9-18.8,133.9-49.8c0.4,0.5,0.6,1.1,1,1.6l130.2,130.2 c4.7,4.7,10.8,7,16.9,7c6.1,0,12.2-2.3,16.9-7C514.3,484.8,514.3,469.7,505,460.4z M206.1,364.5c-87.3,0-158.4-71-158.4-158.4 c0-87.3,71-158.4,158.4-158.4c87.3,0,158.4,71,158.4,158.4C364.5,293.4,293.4,364.5,206.1,364.5z"],
		"play": [448, 512, [], "f04b", "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6zM48 453.5v-395c0-4.6 5.1-7.5 9.1-5.2l334.2 197.5c3.9 2.3 3.9 8 0 10.3L57.1 458.7c-4 2.3-9.1-.6-9.1-5.2z"],
		"sign-out-alt": [512, 512, [], "f2f5", "M272 112v51.6h-96c-26.5 0-48 21.5-48 48v88.6c0 26.5 21.5 48 48 48h96v51.6c0 42.6 51.7 64.2 81.9 33.9l144-143.9c18.7-18.7 18.7-49.1 0-67.9l-144-144C323.8 48 272 69.3 272 112zm192 144L320 400v-99.7H176v-88.6h144V112l144 144zM96 64h84c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H96c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h84c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H96c-53 0-96-43-96-96V160c0-53 43-96 96-96z"],
		"sliders-h": [512, 512, [], "f1de", "M496 72H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24H16C7.2 72 0 79.2 0 88v16c0 8.8 7.2 16 16 16h208v24c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24h208c8.8 0 16-7.2 16-16V88c0-8.8-7.2-16-16-16zm0 320H160v-24c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h80v24c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm0-160h-80v-24c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336v24c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24h80c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"],
		"sort-alpha-down": [384, 512, [], "f15d", "M156.718 404.24l-67.994 72.002c-4.732 5.01-12.713 5.014-17.448 0L3.283 404.24C-3.883 396.652 1.428 384 12.007 384H56V44c0-6.627 5.373-12 12-12h24c6.627 0 12 5.373 12 12v340h43.994c10.587 0 15.884 12.658 8.724 20.24zm105.853-188.933A12 12 0 0 1 251.036 224h-29.133c-8.22 0-14.007-8.078-11.362-15.861l57.097-168A11.999 11.999 0 0 1 278.999 32h35.894c5.139 0 9.708 3.273 11.362 8.139l57.097 168c2.645 7.783-3.141 15.861-11.362 15.861h-29.172a12 12 0 0 1-11.515-8.622l-8.793-29.977h-51.367l-8.572 29.906zm21.463-73.942h25.606l-8.822-30.655c-1.277-4.419-2.651-9.992-3.871-15.241-1.221 5.251-2.595 10.824-3.872 15.245l-9.041 30.651zm7.486 292.104c2.274-2.654 4.985-6.056 7.929-10.235l69.819-99.06a11.999 11.999 0 0 0 2.191-6.913V300c0-6.627-5.373-12-12-12H236.493c-6.627 0-12 5.373-12 12v22.61c0 6.627 5.373 12 12 12h59.682c1.652 0 3.213-.03 4.655-.078-2.274 2.653-4.984 6.055-7.927 10.233l-69.56 98.542a12.001 12.001 0 0 0-2.196 6.92V468c0 6.627 5.373 12 12 12h127.599c6.627 0 12-5.373 12-12v-22.61c0-6.627-5.373-12-12-12h-64.571c-1.652 0-3.213.031-4.655.079z"],
		"th": [512, 512, [], "f00a", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM197.3 72h117.3v96H197.3zm0 136h117.3v96H197.3zm-40 232H52c-6.6 0-12-5.4-12-12v-84h117.3zm0-136H40v-96h117.3zm0-136H40V84c0-6.6 5.4-12 12-12h105.3zm157.4 272H197.3v-96h117.3v96zm157.3 0H354.7v-96H472zm0-136H354.7v-96H472zm0-136H354.7V72H472z"],
		"caret-down": [320, 512, [], "f0d7", "M272 160H48.1c-42.6 0-64.2 51.7-33.9 81.9l111.9 112c18.7 18.7 49.1 18.7 67.9 0l112-112c30-30.1 8.7-81.9-34-81.9zM160 320L48 208h224L160 320z"],
		"caret-up": [320, 512, [], "f0d8", "M48.048 352h223.895c42.638 0 64.151-51.731 33.941-81.941l-111.943-112c-18.745-18.745-49.137-18.746-67.882 0l-111.952 112C-16.042 300.208 5.325 352 48.048 352zM160 192l112 112H48l112-112z"],
		"times": [320, 512, [], "f00d", "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"],
		"laptop": [640, 512, [], "f109", "M624 352h-48V64c0-35.2-28.8-64-64-64H128C92.8 0 64 28.8 64 64v288H16c-8.8 0-16 7.2-16 16v48c0 52.8 43.2 96 96 96h448c52.8 0 96-43.2 96-96v-48c0-8.8-7.2-16-16-16zM112 64c0-8.67 7.33-16 16-16h384c8.67 0 16 7.33 16 16v288H112V64zm480 352c0 26.47-21.53 48-48 48H96c-26.47 0-48-21.53-48-48v-16h180.9c5.57 9.39 15.38 16 27.1 16h128c11.72 0 21.52-6.61 27.1-16H592v16z"],
		"mobile": [320, 512, [], "f10b", "M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zM320 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h212c3.3 0 6-2.7 6-6z"],
		"mobile-alt": [320, 512, [], "f3cd", "M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm48-60V92c0-6.6-5.4-12-12-12H92c-6.6 0-12 5.4-12 12v264c0 6.6 5.4 12 12 12h136c6.6 0 12-5.4 12-12zm80-308v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h212c3.3 0 6-2.7 6-6z"],
		"angle-double-down": [320, 512, [], "f103", "M151.5 427.8L3.5 281c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 362.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0zm17-160l148-146.8c4.7-4.7 4.7-12.3 0-17l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L160 202.7 40.3 84.2c-4.7-4.7-12.3-4.7-17 0L3.5 104c-4.7 4.7-4.7 12.3 0 17l148 146.8c4.7 4.7 12.3 4.7 17 0z"],
		"angle-double-left": [384, 512, [], "f100", "M20.2 247.5L167 99.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L85.3 256l118.5 119.7c4.7 4.7 4.7 12.3 0 17L184 412.5c-4.7 4.7-12.3 4.7-17 0l-146.8-148c-4.7-4.7-4.7-12.3 0-17zm160 17l146.8 148c4.7 4.7 12.3 4.7 17 0l19.8-19.8c4.7-4.7 4.7-12.3 0-17L245.3 256l118.5-119.7c4.7-4.7 4.7-12.3 0-17L344 99.5c-4.7-4.7-12.3-4.7-17 0l-146.8 148c-4.7 4.7-4.7 12.3 0 17z"],
		"angle-double-right": [384, 512, [], "f101", "M363.8 264.5L217 412.5c-4.7 4.7-12.3 4.7-17 0l-19.8-19.8c-4.7-4.7-4.7-12.3 0-17L298.7 256 180.2 136.3c-4.7-4.7-4.7-12.3 0-17L200 99.5c4.7-4.7 12.3-4.7 17 0l146.8 148c4.7 4.7 4.7 12.3 0 17zm-160-17L57 99.5c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8c-4.7 4.7-4.7 12.3 0 17L138.7 256 20.2 375.7c-4.7 4.7-4.7 12.3 0 17L40 412.5c4.7 4.7 12.3 4.7 17 0l146.8-148c4.7-4.7 4.7-12.3 0-17z"],
		"angle-double-up": [320, 512, [], "f102", "M168.5 84.2l148 146.8c4.7 4.7 4.7 12.3 0 17l-19.8 19.8c-4.7 4.7-12.3 4.7-17 0L160 149.3 40.3 267.8c-4.7 4.7-12.3 4.7-17 0L3.5 248c-4.7-4.7-4.7-12.3 0-17l148-146.8c4.7-4.7 12.3-4.7 17 0zm-17 160L3.5 391c-4.7 4.7-4.7 12.3 0 17l19.8 19.8c4.7 4.7 12.3 4.7 17 0L160 309.3l119.7 118.5c4.7 4.7 12.3 4.7 17 0l19.8-19.8c4.7-4.7 4.7-12.3 0-17l-148-146.8c-4.7-4.7-12.3-4.7-17 0z"],
		"angle-down": [512, 289, [], "f107", "M0,47.2L47.2,0L256,208.8L464.8,0L512,47.2L279.6,279.6c-13,13-34.2,13-47.3,0L0,47.2z"],
		"angle-left": [289, 512, [], "f104", "M242.2,0l47.2,47.2L80.6,256l208.8,208.8L242.2,512L9.8,279.6c-13-13-13-34.2,0-47.3L242.2,0z"],
		"angle-right": [289, 512, [], "f105", "M47.2,512L0,464.8L208.8,256L0,47.2L47.2,0l232.4,232.4c13,13,13,34.2,0,47.3L47.2,512z"],
		"angle-up": [512, 289, [], "f106", "M512,242.2l-47.2,47.2L256,80.6L47.2,289.4L0,242.2L232.4,9.8c13-13,34.2-13,47.3,0L512,242.2z"],
		"download": [576, 512, [], "f019", "M528 288h-92.1l46.1-46.1c30.1-30.1 8.8-81.9-33.9-81.9h-64V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v112h-64c-42.6 0-64.2 51.7-33.9 81.9l46.1 46.1H48c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48zm-400-80h112V48h96v160h112L288 368 128 208zm400 256H48V336h140.1l65.9 65.9c18.8 18.8 49.1 18.7 67.9 0l65.9-65.9H528v128zm-88-64c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24-24-10.7-24-24z"],
		"play-circle": [512, 512, [], "f144", "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"],
		"info": [256, 512, [], "f129", "M224 352.589V224c0-16.475-6.258-31.517-16.521-42.872C225.905 161.14 236 135.346 236 108 236 48.313 187.697 0 128 0 68.313 0 20 48.303 20 108c0 20.882 5.886 40.859 16.874 58.037C15.107 176.264 0 198.401 0 224v39.314c0 23.641 12.884 44.329 32 55.411v33.864C12.884 363.671 0 384.359 0 408v40c0 35.29 28.71 64 64 64h128c35.29 0 64-28.71 64-64v-40c0-23.641-12.884-44.329-32-55.411zM128 48c33.137 0 60 26.863 60 60s-26.863 60-60 60-60-26.863-60-60 26.863-60 60-60zm80 400c0 8.836-7.164 16-16 16H64c-8.836 0-16-7.164-16-16v-40c0-8.836 7.164-16 16-16h16V279.314H64c-8.836 0-16-7.164-16-16V224c0-8.836 7.164-16 16-16h96c8.836 0 16 7.164 16 16v168h16c8.836 0 16 7.164 16 16v40z"],
		"calendar": [448, 512, [], "f133", "M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"],
		"map-marker": [384, 512, [], "f041", "M192 0C85.903 0 0 86.014 0 192c0 71.117 23.991 93.341 151.271 297.424 18.785 30.119 62.694 30.083 81.457 0C360.075 285.234 384 263.103 384 192 384 85.903 297.986 0 192 0zm0 464C64.576 259.686 48 246.788 48 192c0-79.529 64.471-144 144-144s144 64.471 144 144c0 54.553-15.166 65.425-144 272z"],
		"university": [512, 512, [], "f19c", "M472 440h-8v-56c0-13.255-10.745-24-24-24h-16V208h-48v152h-48V208h-48v152h-48V208h-48v152h-48V208H88v152H72c-13.255 0-24 10.745-24 24v56h-8c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zm-56 0H96v-32h320v32zm72.267-322.942L271.179 26.463a48.004 48.004 0 0 0-30.358 0L23.733 117.058A11.999 11.999 0 0 0 16 128.274V156c0 6.627 5.373 12 12 12h20v12c0 6.627 5.373 12 12 12h392c6.627 0 12-5.373 12-12v-12h20c6.627 0 12-5.373 12-12v-27.726c0-4.982-3.077-9.445-7.733-11.216zM64 144l192-72 192 72H64z"],
		"external-link-square": [448, 512, [], "f14c", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h340a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-54-304l-136 .145c-6.627 0-12 5.373-12 12V167.9c0 6.722 5.522 12.133 12.243 11.998l58.001-2.141L99.515 340.485c-4.686 4.686-4.686 12.284 0 16.971l23.03 23.029c4.686 4.686 12.284 4.686 16.97 0l162.729-162.729-2.141 58.001c-.136 6.721 5.275 12.242 11.998 12.242h27.755c6.628 0 12-5.373 12-12L352 140c0-6.627-5.373-12-12-12z"],
		"dot-circle": [512, 512, [], "f192", "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"],
		"external-link": [576, 512, [], "f08e", "M576 14.4l-.174 163.2c0 7.953-6.447 14.4-14.4 14.4H528.12c-8.067 0-14.56-6.626-14.397-14.691l2.717-73.627-2.062-2.062-278.863 278.865c-4.686 4.686-12.284 4.686-16.971 0l-23.029-23.029c-4.686-4.686-4.686-12.284 0-16.971L474.379 61.621l-2.062-2.062-73.626 2.717C390.626 62.44 384 55.946 384 47.879V14.574c0-7.953 6.447-14.4 14.4-14.4L561.6 0c7.953 0 14.4 6.447 14.4 14.4zM427.515 233.74l-24 24a12.002 12.002 0 0 0-3.515 8.485V458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h301.976c10.691 0 16.045-12.926 8.485-20.485l-24-24A12.002 12.002 0 0 0 331.976 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V242.225c0-10.691-12.926-16.045-20.485-8.485z"],
		"clock": [512, 512, [], "f017", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"],
		"map-marker-alt": [384, 512, [], "f3c5", "M211,307.9c-48.1,0-87.2-39.1-87.2-87.2s39.1-87.2,87.2-87.2s87.2,39.1,87.2,87.2S259.1,307.9,211,307.9z M211,186 c-19.1,0-34.7,15.5-34.7,34.7c0,19.1,15.6,34.6,34.7,34.6s34.7-15.5,34.7-34.6C245.7,201.5,230.1,186,211,186z M214.4,512c-5.2,0-10.4-1.5-14.9-4.5C191.3,502.1,0,372.7,0,214.4c0-57.2,22.3-111.1,62.8-151.6C103.3,22.3,157.1,0,214.4,0 C270.8,0,326,22.9,365.9,62.8c40.5,40.5,62.8,94.3,62.8,151.6c0,158.4-191.3,287.7-199.4,293.1C224.8,510.5,219.6,512,214.4,512z M214.4,53.9c-42.8,0-83.2,16.7-113.5,47c-30.3,30.3-47,70.6-47,113.5c0,107,118,205.5,160.4,237.5c42.4-32,160.5-130.7,160.5-237.5 c0-42.9-16.7-83.2-47-113.5C297.9,71,256.6,53.9,214.4,53.9z"],
		"envelope": [512, 512, [], "f0e0", "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"],
		"question": [384, 512, [], "f128", "M199.65 0C125.625 0 69.665 30.187 27.21 92.51c-19.17 28.15-12.94 66.3 14.17 86.86l36.73 27.85c10.81 8.2 24.19 12.79 37.74 12.96-11.84 19-17.82 40.61-17.82 64.55v11.43c0 16.38 6.2 31.34 16.38 42.65C97.99 357.2 88 381.45 88 408c0 57.35 46.65 104 104 104s104-46.65 104-104c0-26.55-9.99-50.8-26.41-69.19 8.66-9.62 14.43-21.87 15.97-35.38 28.287-16.853 96-48.895 96-138.21C381.56 71.151 290.539 0 199.65 0zM192 464c-30.88 0-56-25.12-56-56 0-30.873 25.118-56 56-56 30.887 0 56 25.132 56 56 0 30.88-25.12 56-56 56zm45.97-176.21v8.37c0 8.788-7.131 15.84-15.84 15.84h-60.26c-8.708 0-15.84-7.051-15.84-15.84v-11.43c0-47.18 35.77-66.04 62.81-81.2 23.18-13 37.39-21.83 37.39-39.04 0-22.77-29.04-37.88-52.52-37.88-30.61 0-44.74 14.49-64.6 39.56-5.365 6.771-15.157 8.01-22 2.8l-36.73-27.85c-6.74-5.11-8.25-14.6-3.49-21.59C98.08 73.73 137.8 48 199.65 48c64.77 0 133.91 50.56 133.91 117.22 0 88.51-95.59 89.87-95.59 122.57z"],
		"ticket": [576, 512, [], "f145", "M568 216h8V112c0-26.51-21.49-48-48-48H48C21.49 64 0 85.49 0 112v104h8c22.091 0 40 17.909 40 40s-17.909 40-40 40H0v104c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V296h-8c-22.091 0-40-17.909-40-40s17.909-40 40-40zm-40-38.372c-28.47 14.59-48 44.243-48 78.372s19.53 63.782 48 78.372V400H48v-65.628c28.471-14.59 48-44.243 48-78.372s-19.529-63.782-48-78.372V112h480v65.628z"],
		"long-arrow-right": [448, 512, [], "f178", "M295.515 115.716l-19.626 19.626c-4.753 4.753-4.675 12.484.173 17.14L356.78 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h344.78l-80.717 77.518c-4.849 4.656-4.927 12.387-.173 17.14l19.626 19.626c4.686 4.686 12.284 4.686 16.971 0l131.799-131.799c4.686-4.686 4.686-12.284 0-16.971L312.485 115.716c-4.686-4.686-12.284-4.686-16.97 0z"],
		"plus": [512, 512, [], "f067", "M 512.2,224.6 H 288.4 V 0.5 H 224.6 V 224.6 H 0.2 v 63.8 h 224.4 v 224.1 h 63.8 V 288.4 h 223.8 z"],
		"minus": [512, 512, [], "f068", "m 0.2,224.6 v 63.7 h 512 V 224.6 H 163.5 Z"],
		"star": [576, 512, [], "f005", "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"],
		"star-half": [576, 512, [], "f089", "M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"],

	};

	bunker( function() {
		define( 'far', icons );
	} );

}());
(function() {
	'use strict';

	var _WINDOW = {};
	var _DOCUMENT = {};

	try {
		if ( typeof window !== 'undefined' ) _WINDOW = window;
		if ( typeof document !== 'undefined' ) _DOCUMENT = document;
	} catch ( e ) {
	}

	var _ref = _WINDOW.navigator || {},
		_ref$userAgent = _ref.userAgent,
		userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

	var WINDOW = _WINDOW;
	var DOCUMENT = _DOCUMENT;
	var IS_BROWSER = !!WINDOW.document;
	var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
	var IS_IE = ~userAgent.indexOf( 'MSIE' ) || ~userAgent.indexOf( 'Trident/' );

	var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
	var PRODUCTION = function() {
		try {
			return "production" === 'production';
		} catch ( e ) {
			return false;
		}
	}();

	function bunker( fn ) {
		try {
			fn();
		} catch ( e ) {
			if ( !PRODUCTION ) {
				throw e;
			}
		}
	}

	function _defineProperty( obj, key, value ) {
		if ( key in obj ) {
			Object.defineProperty( obj, key, {
				value: value,
				enumerable: true,
				configurable: true,
				writable: true,
			} );
		} else {
			obj[ key ] = value;
		}

		return obj;
	}

	function _objectSpread( target ) {
		for ( var i = 1; i < arguments.length; i++ ) {
			var source = arguments[ i ] != null ? arguments[ i ] : {};
			var ownKeys = Object.keys( source );

			if ( typeof Object.getOwnPropertySymbols === 'function' ) {
				ownKeys = ownKeys.concat( Object.getOwnPropertySymbols( source ).filter( function( sym ) {
					return Object.getOwnPropertyDescriptor( source, sym ).enumerable;
				} ) );
			}

			ownKeys.forEach( function( key ) {
				_defineProperty( target, key, source[ key ] );
			} );
		}

		return target;
	}

	var w = WINDOW || {};
	if ( !w[ NAMESPACE_IDENTIFIER ] ) w[ NAMESPACE_IDENTIFIER ] = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].styles ) w[ NAMESPACE_IDENTIFIER ].styles = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].hooks ) w[ NAMESPACE_IDENTIFIER ].hooks = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].shims ) w[ NAMESPACE_IDENTIFIER ].shims = [];
	var namespace = w[ NAMESPACE_IDENTIFIER ];

	function define( prefix, icons ) {
		var normalized = Object.keys( icons ).reduce( function( acc, iconName ) {
			var icon = icons[ iconName ];
			var expanded = !!icon.icon;

			if ( expanded ) {
				acc[ icon.iconName ] = icon.icon;
			} else {
				acc[ iconName ] = icon;
			}

			return acc;
		}, {} );

		if ( typeof namespace.hooks.addPack === 'function' ) {
			namespace.hooks.addPack( prefix, normalized );
		} else {
			namespace.styles[ prefix ] = _objectSpread( {}, namespace.styles[ prefix ] || {}, normalized );
		}
		/**
		 * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
		 * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
		 * for `fas` so we'll easy the upgrade process for our users by automatically defining
		 * this as well.
		 */


		if ( prefix === 'fas' ) {
			define( 'fa', icons );
		}
	}

	var icons = {
		"search": [512, 512, [], "f002", "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"],
		"play": [448, 512, [], "f04b", "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"],
		"sign-out-alt": [512, 512, [], "f2f5", "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"],
		"sliders-h": [512, 512, [], "f1de", "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"],
		"sort-alpha-down": [384, 512, [], "f15d", "M156.718 404.24l-67.994 72.002c-4.732 5.01-12.713 5.014-17.448 0L3.283 404.24C-3.883 396.652 1.428 384 12.007 384H56V44c0-6.627 5.373-12 12-12h24c6.627 0 12 5.373 12 12v340h43.994c10.587 0 15.884 12.658 8.724 20.24zm105.853-188.933A12 12 0 0 1 251.036 224h-29.133c-8.22 0-14.007-8.078-11.362-15.861l57.097-168A11.999 11.999 0 0 1 278.999 32h35.894c5.139 0 9.708 3.273 11.362 8.139l57.097 168c2.645 7.783-3.141 15.861-11.362 15.861h-29.172a12 12 0 0 1-11.515-8.622l-8.793-29.977h-51.367l-8.572 29.906zm21.463-73.942h25.606l-8.822-30.655c-1.277-4.419-2.651-9.992-3.871-15.241-1.221 5.251-2.595 10.824-3.872 15.245l-9.041 30.651zm7.486 292.104c2.274-2.654 4.985-6.056 7.929-10.235l69.819-99.06a11.999 11.999 0 0 0 2.191-6.913V300c0-6.627-5.373-12-12-12H236.493c-6.627 0-12 5.373-12 12v22.61c0 6.627 5.373 12 12 12h59.682c1.652 0 3.213-.03 4.655-.078-2.274 2.653-4.984 6.055-7.927 10.233l-69.56 98.542a12.001 12.001 0 0 0-2.196 6.92V468c0 6.627 5.373 12 12 12h127.599c6.627 0 12-5.373 12-12v-22.61c0-6.627-5.373-12-12-12h-64.571c-1.652 0-3.213.031-4.655.079z"],
		"th": [512, 512, [], "f00a", "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"],
		"caret-down": [320, 512, [], "f0d7", "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"],
		"caret-up": [320, 512, [], "f0d8", "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"],
		"times": [352, 512, [], "f00d", "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"],
		"laptop": [640, 512, [], "f109", "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"],
		"mobile": [320, 512, [], "f10b", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"],
		"mobile-alt": [320, 512, [], "f3cd", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"],
		"angle-double-down": [320, 512, [], "f103", "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"],
		"angle-double-left": [448, 512, [], "f100", "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"],
		"angle-double-right": [448, 512, [], "f101", "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"],
		"angle-double-up": [320, 512, [], "f102", "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"],
		"angle-down": [320, 512, [], "f107", "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"],
		"angle-left": [256, 512, [], "f104", "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"],
		"angle-right": [256, 512, [], "f105", "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"],
		"angle-up": [320, 512, [], "f106", "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"],
		"download": [512, 512, [], "f019", "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"],
		"play-circle": [512, 512, [], "f144", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"],
		"info": [192, 512, [], "f129", "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"],
		"calendar": [448, 512, [], "f133", "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"],
		"map-marker": [384, 512, [], "f041", "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"],
		"university": [512, 512, [], "f19c", "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"],
		"external-link-square": [448, 512, [], "f14c", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-64 47.111C384 109.929 370.071 96 352.889 96H220.667c-12.887 0-23.333 10.447-23.333 23.334v14.904c0 13.138 10.843 23.686 23.976 23.324l56.002-1.588L69.908 361.908c-7.858 7.802-7.88 20.504-.05 28.334l19.899 19.899c7.83 7.83 20.532 7.808 28.334-.05l205.935-207.404-1.588 56.003c-.362 13.133 10.186 23.976 23.324 23.976h14.904c12.887 0 23.334-10.447 23.334-23.333V127.111z"],
		"dot-circle": [512, 512, [], "f192", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"],
		"external-link": [576, 512, [], "f08e", "M448 279.196V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h248a24 24 0 0 1 16.97 7.029l16 16C344.09 102.149 333.382 128 312 128H64v320h320V295.196c0-6.365 2.529-12.47 7.029-16.971l16-16C422.148 247.106 448 257.814 448 279.196zM576 37.333C576 16.715 559.285 0 538.667 0H380c-15.464 0-28 12.536-28 28v17.885c0 15.766 13.011 28.424 28.772 27.989l67.203-1.906L199.09 319.09c-9.429 9.363-9.457 24.605-.061 34.001l23.879 23.879c9.396 9.396 24.639 9.369 34.001-.06l247.122-248.885-1.906 67.203c-.434 15.76 12.224 28.772 27.99 28.772H548c15.464 0 28-12.536 28-28V37.333z"],
		"clock": [512, 512, [], "f017", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm57.1 350.1L224.9 294c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v137.7l63.5 46.2c5.4 3.9 6.5 11.4 2.6 16.8l-28.2 38.8c-3.9 5.3-11.4 6.5-16.8 2.6z"],
		"map-marker-alt": [384, 512, [], "f3c5", "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"],
		"envelope": [512, 512, [], "f0e0", "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"],
		"question": [384, 512, [], "f128", "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"],
		"ticket": [576, 512, [], "f145", "M576 208v-96c0-26.51-21.49-48-48-48H48C21.49 64 0 85.49 0 112v96c26.51 0 48 21.49 48 48s-21.49 48-48 48v96c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48v-96c-26.51 0-48-21.49-48-48s21.49-48 48-48z"],
		"long-arrow-right": [448, 512, [], "f178", "M254.544 154.427L320.118 220H24c-13.255 0-24 10.745-24 24v24c0 13.255 10.745 24 24 24h296.118l-65.574 65.573c-9.373 9.373-9.373 24.569 0 33.941l16.971 16.971c9.373 9.373 24.569 9.373 33.941 0L440.97 272.97c9.373-9.373 9.373-24.569 0-33.941L305.456 103.515c-9.373-9.373-24.569-9.373-33.941 0l-16.971 16.971c-9.373 9.372-9.373 24.568 0 33.941z"],
		"plus": [448, 512, [], "f067", "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"],
		"minus": [448, 512, [], "f068", "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"],
		"star": [576, 512, [], "f005", "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"],
		"star-half": [576, 512, [], "f089", "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"],

	};

	bunker( function() {
		define( 'fas', icons );
	} );

}());
(function() {
	'use strict';

	function _classCallCheck( instance, Constructor ) {
		if ( !(instance instanceof Constructor) ) {
			throw new TypeError( "Cannot call a class as a function" );
		}
	}

	function _defineProperties( target, props ) {
		for ( var i = 0; i < props.length; i++ ) {
			var descriptor = props[ i ];
			descriptor.enumerable = descriptor.enumerable || false;
			descriptor.configurable = true;
			if ( "value" in descriptor ) descriptor.writable = true;
			Object.defineProperty( target, descriptor.key, descriptor );
		}
	}

	function _createClass( Constructor, protoProps, staticProps ) {
		if ( protoProps ) _defineProperties( Constructor.prototype, protoProps );
		if ( staticProps ) _defineProperties( Constructor, staticProps );
		return Constructor;
	}

	function _defineProperty( obj, key, value ) {
		if ( key in obj ) {
			Object.defineProperty( obj, key, {
				value: value,
				enumerable: true,
				configurable: true,
				writable: true,
			} );
		} else {
			obj[ key ] = value;
		}

		return obj;
	}

	function _objectSpread( target ) {
		for ( var i = 1; i < arguments.length; i++ ) {
			var source = arguments[ i ] != null ? arguments[ i ] : {};
			var ownKeys = Object.keys( source );

			if ( typeof Object.getOwnPropertySymbols === 'function' ) {
				ownKeys = ownKeys.concat( Object.getOwnPropertySymbols( source ).filter( function( sym ) {
					return Object.getOwnPropertyDescriptor( source, sym ).enumerable;
				} ) );
			}

			ownKeys.forEach( function( key ) {
				_defineProperty( target, key, source[ key ] );
			} );
		}

		return target;
	}

	function _slicedToArray( arr, i ) {
		return _arrayWithHoles( arr ) || _iterableToArrayLimit( arr, i ) || _nonIterableRest();
	}

	function _toConsumableArray( arr ) {
		return _arrayWithoutHoles( arr ) || _iterableToArray( arr ) || _nonIterableSpread();
	}

	function _arrayWithoutHoles( arr ) {
		if ( Array.isArray( arr ) ) {
			for ( var i = 0, arr2 = new Array( arr.length ); i < arr.length; i++ ) arr2[ i ] = arr[ i ];

			return arr2;
		}
	}

	function _arrayWithHoles( arr ) {
		if ( Array.isArray( arr ) ) return arr;
	}

	function _iterableToArray( iter ) {
		if ( Symbol.iterator in Object( iter ) || Object.prototype.toString.call( iter ) === "[object Arguments]" ) return Array.from( iter );
	}

	function _iterableToArrayLimit( arr, i ) {
		var _arr = [];
		var _n = true;
		var _d = false;
		var _e = undefined;

		try {
			for ( var _i = arr[ Symbol.iterator ](), _s; !(_n = (_s = _i.next()).done); _n = true ) {
				_arr.push( _s.value );

				if ( i && _arr.length === i ) break;
			}
		} catch ( err ) {
			_d = true;
			_e = err;
		} finally {
			try {
				if ( !_n && _i[ "return" ] != null ) _i[ "return" ]();
			} finally {
				if ( _d ) throw _e;
			}
		}

		return _arr;
	}

	function _nonIterableSpread() {
		throw new TypeError( "Invalid attempt to spread non-iterable instance" );
	}

	function _nonIterableRest() {
		throw new TypeError( "Invalid attempt to destructure non-iterable instance" );
	}

	var noop = function noop() {
	};

	var _WINDOW = {};
	var _DOCUMENT = {};
	var _MUTATION_OBSERVER = null;
	var _PERFORMANCE = {
		mark: noop,
		measure: noop,
	};

	try {
		if ( typeof window !== 'undefined' ) _WINDOW = window;
		if ( typeof document !== 'undefined' ) _DOCUMENT = document;
		if ( typeof MutationObserver !== 'undefined' ) _MUTATION_OBSERVER = MutationObserver;
		if ( typeof performance !== 'undefined' ) _PERFORMANCE = performance;
	} catch ( e ) {
	}

	var _ref = _WINDOW.navigator || {},
		_ref$userAgent = _ref.userAgent,
		userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

	var WINDOW = _WINDOW;
	var DOCUMENT = _DOCUMENT;
	var MUTATION_OBSERVER = _MUTATION_OBSERVER;
	var PERFORMANCE = _PERFORMANCE;
	var IS_BROWSER = !!WINDOW.document;
	var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
	var IS_IE = ~userAgent.indexOf( 'MSIE' ) || ~userAgent.indexOf( 'Trident/' );

	var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
	var UNITS_IN_GRID = 16;
	var DEFAULT_FAMILY_PREFIX = 'fa';
	var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
	var DATA_FA_I2SVG = 'data-fa-i2svg';
	var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
	var DATA_PREFIX = 'data-prefix';
	var DATA_ICON = 'data-icon';
	var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
	var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
	var PRODUCTION = function() {
		try {
			return "production" === 'production';
		} catch ( e ) {
			return false;
		}
	}();
	var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	var oneToTwenty = oneToTen.concat( [11, 12, 13, 14, 15, 16, 17, 18, 19, 20] );
	var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
	var RESERVED_CLASSES = ['xs', 'sm', 'lg', 'fw', 'ul', 'li', 'border', 'pull-left', 'pull-right', 'spin', 'pulse', 'rotate-90', 'rotate-180', 'rotate-270', 'flip-horizontal', 'flip-vertical', 'stack', 'stack-1x', 'stack-2x', 'inverse', 'layers', 'layers-text', 'layers-counter'].concat( oneToTen.map( function( n ) {
		return "".concat( n, "x" );
	} ) ).concat( oneToTwenty.map( function( n ) {
		return "w-".concat( n );
	} ) );

	var initial = WINDOW.FontAwesomeConfig || {};

	function getAttrConfig( attr ) {
		var element = DOCUMENT.querySelector( 'script[' + attr + ']' );

		if ( element ) {
			return element.getAttribute( attr );
		}
	}

	function coerce( val ) {
		// Getting an empty string will occur if the attribute is set on the HTML tag but without a value
		// We'll assume that this is an indication that it should be toggled to true
		// For example <script data-search-pseudo-elements src="..."></script>
		if ( val === '' ) return true;
		if ( val === 'false' ) return false;
		if ( val === 'true' ) return true;
		return val;
	}

	if ( DOCUMENT && typeof DOCUMENT.querySelector === 'function' ) {
		var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
		attrs.forEach( function( _ref ) {
			var _ref2 = _slicedToArray( _ref, 2 ),
				attr = _ref2[ 0 ],
				key = _ref2[ 1 ];

			var val = coerce( getAttrConfig( attr ) );

			if ( val !== undefined && val !== null ) {
				initial[ key ] = val;
			}
		} );
	}

	var _default = _objectSpread( {
		familyPrefix: DEFAULT_FAMILY_PREFIX,
		replacementClass: DEFAULT_REPLACEMENT_CLASS,
		autoReplaceSvg: true,
		autoAddCss: true,
		autoA11y: true,
		searchPseudoElements: false,
		observeMutations: true,
		keepOriginalSource: true,
		measurePerformance: false,
		showMissingIcons: true,
	}, initial );

	if ( !_default.autoReplaceSvg ) _default.observeMutations = false;

	var config = _objectSpread( {}, _default );

	WINDOW.FontAwesomeConfig = config;

	var w = WINDOW || {};
	if ( !w[ NAMESPACE_IDENTIFIER ] ) w[ NAMESPACE_IDENTIFIER ] = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].styles ) w[ NAMESPACE_IDENTIFIER ].styles = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].hooks ) w[ NAMESPACE_IDENTIFIER ].hooks = {};
	if ( !w[ NAMESPACE_IDENTIFIER ].shims ) w[ NAMESPACE_IDENTIFIER ].shims = [];
	var namespace = w[ NAMESPACE_IDENTIFIER ];

	var functions = [];

	var listener = function listener() {
		DOCUMENT.removeEventListener( 'DOMContentLoaded', listener );
		loaded = 1;
		functions.map( function( fn ) {
			return fn();
		} );
	};

	var loaded = false;

	if ( IS_DOM ) {
		loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test( DOCUMENT.readyState );
		if ( !loaded ) DOCUMENT.addEventListener( 'DOMContentLoaded', listener );
	}

	function domready( fn ) {
		if ( !IS_DOM ) return;
		loaded ? setTimeout( fn, 0 ) : functions.push( fn );
	}

	var d = UNITS_IN_GRID;
	var meaninglessTransform = {
		size: 16,
		x: 0,
		y: 0,
		rotate: 0,
		flipX: false,
		flipY: false,
	};

	function isReserved( name ) {
		return ~RESERVED_CLASSES.indexOf( name );
	}

	function bunker( fn ) {
		try {
			fn();
		} catch ( e ) {
			if ( !PRODUCTION ) {
				throw e;
			}
		}
	}

	function insertCss( css ) {
		if ( !css || !IS_DOM ) {
			return;
		}

		var style = DOCUMENT.createElement( 'style' );
		style.setAttribute( 'type', 'text/css' );
		style.innerHTML = css;
		var headChildren = DOCUMENT.head.childNodes;
		var beforeChild = null;

		for ( var i = headChildren.length - 1; i > -1; i-- ) {
			var child = headChildren[ i ];
			var tagName = (child.tagName || '').toUpperCase();

			if ( ['STYLE', 'LINK'].indexOf( tagName ) > -1 ) {
				beforeChild = child;
			}
		}

		DOCUMENT.head.insertBefore( style, beforeChild );
		return css;
	}

	var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

	function nextUniqueId() {
		var size = 12;
		var id = '';

		while ( size-- > 0 ) {
			id += idPool[ Math.random() * 62 | 0 ];
		}

		return id;
	}

	function toArray( obj ) {
		var array = [];

		for ( var i = (obj || []).length >>> 0; i--; ) {
			array[ i ] = obj[ i ];
		}

		return array;
	}

	function classArray( node ) {
		if ( node.classList ) {
			return toArray( node.classList );
		} else {
			return (node.getAttribute( 'class' ) || '').split( ' ' ).filter( function( i ) {
				return i;
			} );
		}
	}

	function getIconName( familyPrefix, cls ) {
		var parts = cls.split( '-' );
		var prefix = parts[ 0 ];
		var iconName = parts.slice( 1 ).join( '-' );

		if ( prefix === familyPrefix && iconName !== '' && !isReserved( iconName ) ) {
			return iconName;
		} else {
			return null;
		}
	}

	function htmlEscape( str ) {
		return "".concat( str ).replace( /&/g, '&amp;' ).replace( /"/g, '&quot;' ).replace( /'/g, '&#39;' ).replace( /</g, '&lt;' ).replace( />/g, '&gt;' );
	}

	function joinAttributes( attributes ) {
		return Object.keys( attributes || {} ).reduce( function( acc, attributeName ) {
			return acc + "".concat( attributeName, "=\"" ).concat( htmlEscape( attributes[ attributeName ] ), "\" " );
		}, '' ).trim();
	}

	function joinStyles( styles ) {
		return Object.keys( styles || {} ).reduce( function( acc, styleName ) {
			return acc + "".concat( styleName, ": " ).concat( styles[ styleName ], ";" );
		}, '' );
	}

	function transformIsMeaningful( transform ) {
		return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
	}

	function transformForSvg( _ref ) {
		var transform = _ref.transform,
			containerWidth = _ref.containerWidth,
			iconWidth = _ref.iconWidth;
		var outer = {
			transform: "translate(".concat( containerWidth / 2, " 256)" ),
		};
		var innerTranslate = "translate(".concat( transform.x * 32, ", " ).concat( transform.y * 32, ") " );
		var innerScale = "scale(".concat( transform.size / 16 * (transform.flipX ? -1 : 1), ", " ).concat( transform.size / 16 * (transform.flipY ? -1 : 1), ") " );
		var innerRotate = "rotate(".concat( transform.rotate, " 0 0)" );
		var inner = {
			transform: "".concat( innerTranslate, " " ).concat( innerScale, " " ).concat( innerRotate ),
		};
		var path = {
			transform: "translate(".concat( iconWidth / 2 * -1, " -256)" ),
		};
		return {
			outer: outer,
			inner: inner,
			path: path,
		};
	}

	function transformForCss( _ref2 ) {
		var transform = _ref2.transform,
			_ref2$width = _ref2.width,
			width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
			_ref2$height = _ref2.height,
			height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
			_ref2$startCentered = _ref2.startCentered,
			startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
		var val = '';

		if ( startCentered && IS_IE ) {
			val += "translate(".concat( transform.x / d - width / 2, "em, " ).concat( transform.y / d - height / 2, "em) " );
		} else if ( startCentered ) {
			val += "translate(calc(-50% + ".concat( transform.x / d, "em), calc(-50% + " ).concat( transform.y / d, "em)) " );
		} else {
			val += "translate(".concat( transform.x / d, "em, " ).concat( transform.y / d, "em) " );
		}

		val += "scale(".concat( transform.size / d * (transform.flipX ? -1 : 1), ", " ).concat( transform.size / d * (transform.flipY ? -1 : 1), ") " );
		val += "rotate(".concat( transform.rotate, "deg) " );
		return val;
	}

	var ALL_SPACE = {
		x: 0,
		y: 0,
		width: '100%',
		height: '100%',
	};

	function makeIconMasking( _ref ) {
		var children = _ref.children,
			attributes = _ref.attributes,
			main = _ref.main,
			mask = _ref.mask,
			transform = _ref.transform;
		var mainWidth = main.width,
			mainPath = main.icon;
		var maskWidth = mask.width,
			maskPath = mask.icon;
		var trans = transformForSvg( {
			transform: transform,
			containerWidth: maskWidth,
			iconWidth: mainWidth,
		} );
		var maskRect = {
			tag: 'rect',
			attributes: _objectSpread( {}, ALL_SPACE, {
				fill: 'white',
			} ),
		};
		var maskInnerGroup = {
			tag: 'g',
			attributes: _objectSpread( {}, trans.inner ),
			children: [{
				tag: 'path',
				attributes: _objectSpread( {}, mainPath.attributes, trans.path, {
					fill: 'black',
				} ),
			}],
		};
		var maskOuterGroup = {
			tag: 'g',
			attributes: _objectSpread( {}, trans.outer ),
			children: [maskInnerGroup],
		};
		var maskId = "mask-".concat( nextUniqueId() );
		var clipId = "clip-".concat( nextUniqueId() );
		var maskTag = {
			tag: 'mask',
			attributes: _objectSpread( {}, ALL_SPACE, {
				id: maskId,
				maskUnits: 'userSpaceOnUse',
				maskContentUnits: 'userSpaceOnUse',
			} ),
			children: [maskRect, maskOuterGroup],
		};
		var defs = {
			tag: 'defs',
			children: [{
				tag: 'clipPath',
				attributes: {
					id: clipId,
				},
				children: [maskPath],
			}, maskTag],
		};
		children.push( defs, {
			tag: 'rect',
			attributes: _objectSpread( {
				fill: 'currentColor',
				'clip-path': "url(#".concat( clipId, ")" ),
				mask: "url(#".concat( maskId, ")" ),
			}, ALL_SPACE ),
		} );
		return {
			children: children,
			attributes: attributes,
		};
	}

	function makeIconStandard( _ref ) {
		var children = _ref.children,
			attributes = _ref.attributes,
			main = _ref.main,
			transform = _ref.transform,
			styles = _ref.styles;
		var styleString = joinStyles( styles );

		if ( styleString.length > 0 ) {
			attributes[ 'style' ] = styleString;
		}

		if ( transformIsMeaningful( transform ) ) {
			var trans = transformForSvg( {
				transform: transform,
				containerWidth: main.width,
				iconWidth: main.width,
			} );
			children.push( {
				tag: 'g',
				attributes: _objectSpread( {}, trans.outer ),
				children: [{
					tag: 'g',
					attributes: _objectSpread( {}, trans.inner ),
					children: [{
						tag: main.icon.tag,
						children: main.icon.children,
						attributes: _objectSpread( {}, main.icon.attributes, trans.path ),
					}],
				}],
			} );
		} else {
			children.push( main.icon );
		}

		return {
			children: children,
			attributes: attributes,
		};
	}

	function asIcon( _ref ) {
		var children = _ref.children,
			main = _ref.main,
			mask = _ref.mask,
			attributes = _ref.attributes,
			styles = _ref.styles,
			transform = _ref.transform;

		if ( transformIsMeaningful( transform ) && main.found && !mask.found ) {
			var width = main.width,
				height = main.height;
			var offset = {
				x: width / height / 2,
				y: 0.5,
			};
			attributes[ 'style' ] = joinStyles( _objectSpread( {}, styles, {
				'transform-origin': "".concat( offset.x + transform.x / 16, "em " ).concat( offset.y + transform.y / 16, "em" ),
			} ) );
		}

		return [{
			tag: 'svg',
			attributes: attributes,
			children: children,
		}];
	}

	function asSymbol( _ref ) {
		var prefix = _ref.prefix,
			iconName = _ref.iconName,
			children = _ref.children,
			attributes = _ref.attributes,
			symbol = _ref.symbol;
		var id = symbol === true ? "".concat( prefix, "-" ).concat( config.familyPrefix, "-" ).concat( iconName ) : symbol;
		return [{
			tag: 'svg',
			attributes: {
				style: 'display: none;',
			},
			children: [{
				tag: 'symbol',
				attributes: _objectSpread( {}, attributes, {
					id: id,
				} ),
				children: children,
			}],
		}];
	}

	function makeInlineSvgAbstract( params ) {
		var _params$icons = params.icons,
			main = _params$icons.main,
			mask = _params$icons.mask,
			prefix = params.prefix,
			iconName = params.iconName,
			transform = params.transform,
			symbol = params.symbol,
			title = params.title,
			extra = params.extra,
			_params$watchable = params.watchable,
			watchable = _params$watchable === void 0 ? false : _params$watchable;

		var _ref = mask.found ? mask : main,
			width = _ref.width,
			height = _ref.height;

		var widthClass = "fa-w-".concat( Math.ceil( width / height * 16 ) );
		var attrClass = [config.replacementClass, iconName ? "".concat( config.familyPrefix, "-" ).concat( iconName ) : '', widthClass].filter( function( c ) {
			return extra.classes.indexOf( c ) === -1;
		} ).concat( extra.classes ).join( ' ' );
		var content = {
			children: [],
			attributes: _objectSpread( {}, extra.attributes, {
				'data-prefix': prefix,
				'data-icon': iconName,
				'class': attrClass,
				'role': 'img',
				'xmlns': 'http://www.w3.org/2000/svg',
				'viewBox': "0 0 ".concat( width, " " ).concat( height ),
			} ),
		};

		if ( watchable ) {
			content.attributes[ DATA_FA_I2SVG ] = '';
		}

		if ( title ) content.children.push( {
			tag: 'title',
			attributes: {
				id: content.attributes[ 'aria-labelledby' ] || "title-".concat( nextUniqueId() ),
			},
			children: [title],
		} );

		var args = _objectSpread( {}, content, {
			prefix: prefix,
			iconName: iconName,
			main: main,
			mask: mask,
			transform: transform,
			symbol: symbol,
			styles: extra.styles,
		} );

		var _ref2 = mask.found && main.found ? makeIconMasking( args ) : makeIconStandard( args ),
			children = _ref2.children,
			attributes = _ref2.attributes;

		args.children = children;
		args.attributes = attributes;

		if ( symbol ) {
			return asSymbol( args );
		} else {
			return asIcon( args );
		}
	}

	function makeLayersTextAbstract( params ) {
		var content = params.content,
			width = params.width,
			height = params.height,
			transform = params.transform,
			title = params.title,
			extra = params.extra,
			_params$watchable2 = params.watchable,
			watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

		var attributes = _objectSpread( {}, extra.attributes, title ? {
			'title': title,
		} : {}, {
			'class': extra.classes.join( ' ' ),
		} );

		if ( watchable ) {
			attributes[ DATA_FA_I2SVG ] = '';
		}

		var styles = _objectSpread( {}, extra.styles );

		if ( transformIsMeaningful( transform ) ) {
			styles[ 'transform' ] = transformForCss( {
				transform: transform,
				startCentered: true,
				width: width,
				height: height,
			} );
			styles[ '-webkit-transform' ] = styles[ 'transform' ];
		}

		var styleString = joinStyles( styles );

		if ( styleString.length > 0 ) {
			attributes[ 'style' ] = styleString;
		}

		var val = [];
		val.push( {
			tag: 'span',
			attributes: attributes,
			children: [content],
		} );

		if ( title ) {
			val.push( {
				tag: 'span',
				attributes: {
					class: 'sr-only',
				},
				children: [title],
			} );
		}

		return val;
	}

	function makeLayersCounterAbstract( params ) {
		var content = params.content,
			title = params.title,
			extra = params.extra;

		var attributes = _objectSpread( {}, extra.attributes, title ? {
			'title': title,
		} : {}, {
			'class': extra.classes.join( ' ' ),
		} );

		var styleString = joinStyles( extra.styles );

		if ( styleString.length > 0 ) {
			attributes[ 'style' ] = styleString;
		}

		var val = [];
		val.push( {
			tag: 'span',
			attributes: attributes,
			children: [content],
		} );

		if ( title ) {
			val.push( {
				tag: 'span',
				attributes: {
					class: 'sr-only',
				},
				children: [title],
			} );
		}

		return val;
	}

	var noop$1 = function noop() {
	};

	var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
		mark: noop$1,
		measure: noop$1,
	};
	var preamble = "FA \"5.6.3\"";

	var begin = function begin( name ) {
		p.mark( "".concat( preamble, " " ).concat( name, " begins" ) );
		return function() {
			return end( name );
		};
	};

	var end = function end( name ) {
		p.mark( "".concat( preamble, " " ).concat( name, " ends" ) );
		p.measure( "".concat( preamble, " " ).concat( name ), "".concat( preamble, " " ).concat( name, " begins" ), "".concat( preamble, " " ).concat( name, " ends" ) );
	};

	var perf = {
		begin: begin,
		end: end,
	};

	/**
	 * Internal helper to bind a function known to have 4 arguments
	 * to a given context.
	 */

	var bindInternal4 = function bindInternal4( func, thisContext ) {
		return function( a, b, c, d ) {
			return func.call( thisContext, a, b, c, d );
		};
	};

	/**
	 * # Reduce
	 *
	 * A fast object `.reduce()` implementation.
	 *
	 * @param  {Object}   subject      The object to reduce over.
	 * @param  {Function} fn           The reducer function.
	 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
	 * @param  {Object}   thisContext  The context for the reducer.
	 * @return {mixed}                 The final result.
	 */


	var reduce = function fastReduceObject( subject, fn, initialValue, thisContext ) {
		var keys = Object.keys( subject ),
			length = keys.length,
			iterator = thisContext !== undefined ? bindInternal4( fn, thisContext ) : fn,
			i,
			key,
			result;

		if ( initialValue === undefined ) {
			i = 1;
			result = subject[ keys[ 0 ] ];
		} else {
			i = 0;
			result = initialValue;
		}

		for ( ; i < length; i++ ) {
			key = keys[ i ];
			result = iterator( result, subject[ key ], key, subject );
		}

		return result;
	};

	var styles = namespace.styles,
		shims = namespace.shims;
	var _byUnicode = {};
	var _byLigature = {};
	var _byOldName = {};
	var build = function build() {
		var lookup = function lookup( reducer ) {
			return reduce( styles, function( o, style, prefix ) {
				o[ prefix ] = reduce( style, reducer, {} );
				return o;
			}, {} );
		};

		_byUnicode = lookup( function( acc, icon, iconName ) {
			acc[ icon[ 3 ] ] = iconName;
			return acc;
		} );
		_byLigature = lookup( function( acc, icon, iconName ) {
			var ligatures = icon[ 2 ];
			acc[ iconName ] = iconName;
			ligatures.forEach( function( ligature ) {
				acc[ ligature ] = iconName;
			} );
			return acc;
		} );
		var hasRegular = 'far' in styles;
		_byOldName = reduce( shims, function( acc, shim ) {
			var oldName = shim[ 0 ];
			var prefix = shim[ 1 ];
			var iconName = shim[ 2 ];

			if ( prefix === 'far' && !hasRegular ) {
				prefix = 'fas';
			}

			acc[ oldName ] = {
				prefix: prefix,
				iconName: iconName,
			};
			return acc;
		}, {} );
	};
	build();

	function byUnicode( prefix, unicode ) {
		return _byUnicode[ prefix ][ unicode ];
	}

	function byLigature( prefix, ligature ) {
		return _byLigature[ prefix ][ ligature ];
	}

	function byOldName( name ) {
		return _byOldName[ name ] || {
			prefix: null,
			iconName: null,
		};
	}

	var styles$1 = namespace.styles;
	var emptyCanonicalIcon = function emptyCanonicalIcon() {
		return {
			prefix: null,
			iconName: null,
			rest: [],
		};
	};

	function getCanonicalIcon( values ) {
		return values.reduce( function( acc, cls ) {
			var iconName = getIconName( config.familyPrefix, cls );

			if ( styles$1[ cls ] ) {
				acc.prefix = cls;
			} else if ( iconName ) {
				var shim = acc.prefix === 'fa' ? byOldName( iconName ) : {};
				acc.iconName = shim.iconName || iconName;
				acc.prefix = shim.prefix || acc.prefix;
			} else if ( cls !== config.replacementClass && cls.indexOf( 'fa-w-' ) !== 0 ) {
				acc.rest.push( cls );
			}

			return acc;
		}, emptyCanonicalIcon() );
	}

	function iconFromMapping( mapping, prefix, iconName ) {
		if ( mapping && mapping[ prefix ] && mapping[ prefix ][ iconName ] ) {
			return {
				prefix: prefix,
				iconName: iconName,
				icon: mapping[ prefix ][ iconName ],
			};
		}
	}

	function toHtml( abstractNodes ) {
		var tag = abstractNodes.tag,
			_abstractNodes$attrib = abstractNodes.attributes,
			attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
			_abstractNodes$childr = abstractNodes.children,
			children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

		if ( typeof abstractNodes === 'string' ) {
			return htmlEscape( abstractNodes );
		} else {
			return "<".concat( tag, " " ).concat( joinAttributes( attributes ), ">" ).concat( children.map( toHtml ).join( '' ), "</" ).concat( tag, ">" );
		}
	}

	var noop$2 = function noop() {
	};

	function isWatched( node ) {
		var i2svg = node.getAttribute ? node.getAttribute( DATA_FA_I2SVG ) : null;
		return typeof i2svg === 'string';
	}

	function getMutator() {
		if ( config.autoReplaceSvg === true ) {
			return mutators.replace;
		}

		var mutator = mutators[ config.autoReplaceSvg ];
		return mutator || mutators.replace;
	}

	var mutators = {
		replace: function replace( mutation ) {
			var node = mutation[ 0 ];
			var abstract = mutation[ 1 ];
			var newOuterHTML = abstract.map( function( a ) {
				return toHtml( a );
			} ).join( '\n' );

			if ( node.parentNode && node.outerHTML ) {
				node.outerHTML = newOuterHTML + (config.keepOriginalSource && node.tagName.toLowerCase() !== 'svg' ? "<!-- ".concat( node.outerHTML, " -->" ) : '');
			} else if ( node.parentNode ) {
				var newNode = document.createElement( 'span' );
				node.parentNode.replaceChild( newNode, node );
				newNode.outerHTML = newOuterHTML;
			}
		},
		nest: function nest( mutation ) {
			var node = mutation[ 0 ];
			var abstract = mutation[ 1 ]; // If we already have a replaced node we do not want to continue nesting within it.
			// Short-circuit to the standard replacement

			if ( ~classArray( node ).indexOf( config.replacementClass ) ) {
				return mutators.replace( mutation );
			}

			var forSvg = new RegExp( "".concat( config.familyPrefix, "-.*" ) );
			delete abstract[ 0 ].attributes.style;
			var splitClasses = abstract[ 0 ].attributes.class.split( ' ' ).reduce( function( acc, cls ) {
				if ( cls === config.replacementClass || cls.match( forSvg ) ) {
					acc.toSvg.push( cls );
				} else {
					acc.toNode.push( cls );
				}

				return acc;
			}, {
				toNode: [],
				toSvg: [],
			} );
			abstract[ 0 ].attributes.class = splitClasses.toSvg.join( ' ' );
			var newInnerHTML = abstract.map( function( a ) {
				return toHtml( a );
			} ).join( '\n' );
			node.setAttribute( 'class', splitClasses.toNode.join( ' ' ) );
			node.setAttribute( DATA_FA_I2SVG, '' );
			node.innerHTML = newInnerHTML;
		},
	};

	function perform( mutations, callback ) {
		var callbackFunction = typeof callback === 'function' ? callback : noop$2;

		if ( mutations.length === 0 ) {
			callbackFunction();
		} else {
			var frame = WINDOW.requestAnimationFrame || function( op ) {
				return op();
			};

			frame( function() {
				var mutator = getMutator();
				var mark = perf.begin( 'mutate' );
				mutations.map( mutator );
				mark();
				callbackFunction();
			} );
		}
	}

	var disabled = false;

	function disableObservation( operation ) {
		disabled = true;
		operation();
		disabled = false;
	}

	var mo = null;

	function observe( options ) {
		if ( !MUTATION_OBSERVER ) {
			return;
		}

		if ( !config.observeMutations ) {
			return;
		}

		var treeCallback = options.treeCallback,
			nodeCallback = options.nodeCallback,
			pseudoElementsCallback = options.pseudoElementsCallback,
			_options$observeMutat = options.observeMutationsRoot,
			observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT.body : _options$observeMutat;
		mo = new MUTATION_OBSERVER( function( objects ) {
			if ( disabled ) return;
			toArray( objects ).forEach( function( mutationRecord ) {
				if ( mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched( mutationRecord.addedNodes[ 0 ] ) ) {
					if ( config.searchPseudoElements ) {
						pseudoElementsCallback( mutationRecord.target );
					}

					treeCallback( mutationRecord.target );
				}

				if ( mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements ) {
					pseudoElementsCallback( mutationRecord.target.parentNode );
				}

				if ( mutationRecord.type === 'attributes' && isWatched( mutationRecord.target ) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf( mutationRecord.attributeName ) ) {
					if ( mutationRecord.attributeName === 'class' ) {
						var _getCanonicalIcon = getCanonicalIcon( classArray( mutationRecord.target ) ),
							prefix = _getCanonicalIcon.prefix,
							iconName = _getCanonicalIcon.iconName;

						if ( prefix ) mutationRecord.target.setAttribute( 'data-prefix', prefix );
						if ( iconName ) mutationRecord.target.setAttribute( 'data-icon', iconName );
					} else {
						nodeCallback( mutationRecord.target );
					}
				}
			} );
		} );
		if ( !IS_DOM ) return;
		mo.observe( observeMutationsRoot, {
			childList: true,
			attributes: true,
			characterData: true,
			subtree: true,
		} );
	}

	function disconnect() {
		if ( !mo ) return;
		mo.disconnect();
	}

	function styleParser( node ) {
		var style = node.getAttribute( 'style' );
		var val = [];

		if ( style ) {
			val = style.split( ';' ).reduce( function( acc, style ) {
				var styles = style.split( ':' );
				var prop = styles[ 0 ];
				var value = styles.slice( 1 );

				if ( prop && value.length > 0 ) {
					acc[ prop ] = value.join( ':' ).trim();
				}

				return acc;
			}, {} );
		}

		return val;
	}

	function toHex( unicode ) {
		var result = '';

		for ( var i = 0; i < unicode.length; i++ ) {
			var hex = unicode.charCodeAt( i ).toString( 16 );
			result += ('000' + hex).slice( -4 );
		}

		return result;
	}

	function classParser( node ) {
		var existingPrefix = node.getAttribute( 'data-prefix' );
		var existingIconName = node.getAttribute( 'data-icon' );
		var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
		var val = getCanonicalIcon( classArray( node ) );

		if ( existingPrefix && existingIconName ) {
			val.prefix = existingPrefix;
			val.iconName = existingIconName;
		}

		if ( val.prefix && innerText.length > 1 ) {
			val.iconName = byLigature( val.prefix, node.innerText );
		} else if ( val.prefix && innerText.length === 1 ) {
			val.iconName = byUnicode( val.prefix, toHex( node.innerText ) );
		}

		return val;
	}

	var parseTransformString = function parseTransformString( transformString ) {
		var transform = {
			size: 16,
			x: 0,
			y: 0,
			flipX: false,
			flipY: false,
			rotate: 0,
		};

		if ( !transformString ) {
			return transform;
		} else {
			return transformString.toLowerCase().split( ' ' ).reduce( function( acc, n ) {
				var parts = n.toLowerCase().split( '-' );
				var first = parts[ 0 ];
				var rest = parts.slice( 1 ).join( '-' );

				if ( first && rest === 'h' ) {
					acc.flipX = true;
					return acc;
				}

				if ( first && rest === 'v' ) {
					acc.flipY = true;
					return acc;
				}

				rest = parseFloat( rest );

				if ( isNaN( rest ) ) {
					return acc;
				}

				switch ( first ) {
					case 'grow':
						acc.size = acc.size + rest;
						break;

					case 'shrink':
						acc.size = acc.size - rest;
						break;

					case 'left':
						acc.x = acc.x - rest;
						break;

					case 'right':
						acc.x = acc.x + rest;
						break;

					case 'up':
						acc.y = acc.y - rest;
						break;

					case 'down':
						acc.y = acc.y + rest;
						break;

					case 'rotate':
						acc.rotate = acc.rotate + rest;
						break;
				}

				return acc;
			}, transform );
		}
	};

	function transformParser( node ) {
		return parseTransformString( node.getAttribute( 'data-fa-transform' ) );
	}

	function symbolParser( node ) {
		var symbol = node.getAttribute( 'data-fa-symbol' );
		return symbol === null ? false : symbol === '' ? true : symbol;
	}

	function attributesParser( node ) {
		var extraAttributes = toArray( node.attributes ).reduce( function( acc, attr ) {
			if ( acc.name !== 'class' && acc.name !== 'style' ) {
				acc[ attr.name ] = attr.value;
			}

			return acc;
		}, {} );
		var title = node.getAttribute( 'title' );

		if ( config.autoA11y ) {
			if ( title ) {
				extraAttributes[ 'aria-labelledby' ] = "".concat( config.replacementClass, "-title-" ).concat( nextUniqueId() );
			} else {
				extraAttributes[ 'aria-hidden' ] = 'true';
			}
		}

		return extraAttributes;
	}

	function maskParser( node ) {
		var mask = node.getAttribute( 'data-fa-mask' );

		if ( !mask ) {
			return emptyCanonicalIcon();
		} else {
			return getCanonicalIcon( mask.split( ' ' ).map( function( i ) {
				return i.trim();
			} ) );
		}
	}

	var blankMeta = {
		iconName: null,
		title: null,
		prefix: null,
		transform: meaninglessTransform,
		symbol: false,
		mask: null,
		extra: {
			classes: [],
			styles: {},
			attributes: {},
		},
	};

	function parseMeta( node ) {
		var _classParser = classParser( node ),
			iconName = _classParser.iconName,
			prefix = _classParser.prefix,
			extraClasses = _classParser.rest;

		var extraStyles = styleParser( node );
		var transform = transformParser( node );
		var symbol = symbolParser( node );
		var extraAttributes = attributesParser( node );
		var mask = maskParser( node );
		return {
			iconName: iconName,
			title: node.getAttribute( 'title' ),
			prefix: prefix,
			transform: transform,
			symbol: symbol,
			mask: mask,
			extra: {
				classes: extraClasses,
				styles: extraStyles,
				attributes: extraAttributes,
			},
		};
	}

	function MissingIcon( error ) {
		this.name = 'MissingIcon';
		this.message = error || 'Icon unavailable';
		this.stack = new Error().stack;
	}

	MissingIcon.prototype = Object.create( Error.prototype );
	MissingIcon.prototype.constructor = MissingIcon;

	var FILL = {
		fill: 'currentColor',
	};
	var ANIMATION_BASE = {
		attributeType: 'XML',
		repeatCount: 'indefinite',
		dur: '2s',
	};
	var RING = {
		tag: 'path',
		attributes: _objectSpread( {}, FILL, {
			d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z',
		} ),
	};

	var OPACITY_ANIMATE = _objectSpread( {}, ANIMATION_BASE, {
		attributeName: 'opacity',
	} );

	var DOT = {
		tag: 'circle',
		attributes: _objectSpread( {}, FILL, {
			cx: '256',
			cy: '364',
			r: '28',
		} ),
		children: [{
			tag: 'animate',
			attributes: _objectSpread( {}, ANIMATION_BASE, {
				attributeName: 'r',
				values: '28;14;28;28;14;28;',
			} ),
		}, {
			tag: 'animate',
			attributes: _objectSpread( {}, OPACITY_ANIMATE, {
				values: '1;0;1;1;0;1;',
			} ),
		}],
	};
	var QUESTION = {
		tag: 'path',
		attributes: _objectSpread( {}, FILL, {
			opacity: '1',
			d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z',
		} ),
		children: [{
			tag: 'animate',
			attributes: _objectSpread( {}, OPACITY_ANIMATE, {
				values: '1;0;0;0;0;1;',
			} ),
		}],
	};
	var EXCLAMATION = {
		tag: 'path',
		attributes: _objectSpread( {}, FILL, {
			opacity: '0',
			d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z',
		} ),
		children: [{
			tag: 'animate',
			attributes: _objectSpread( {}, OPACITY_ANIMATE, {
				values: '0;0;1;1;0;0;',
			} ),
		}],
	};
	var missing = {
		tag: 'g',
		children: [RING, DOT, QUESTION, EXCLAMATION],
	};

	var styles$2 = namespace.styles;
	var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
	var FONT_FAMILY_PATTERN = /Font Awesome 5 (Solid|Regular|Light|Brands|Free|Pro)/;
	var STYLE_TO_PREFIX = {
		'Solid': 'fas',
		'Regular': 'far',
		'Light': 'fal',
		'Brands': 'fab',
	};
	var FONT_WEIGHT_TO_PREFIX = {
		'900': 'fas',
		'400': 'far',
		'300': 'fal',
	};

	function findIcon( iconName, prefix ) {
		var val = {
			found: false,
			width: 512,
			height: 512,
			icon: missing,
		};

		if ( iconName && prefix && styles$2[ prefix ] && styles$2[ prefix ][ iconName ] ) {
			var icon = styles$2[ prefix ][ iconName ];
			var width = icon[ 0 ];
			var height = icon[ 1 ];
			var vectorData = icon.slice( 4 );
			val = {
				found: true,
				width: width,
				height: height,
				icon: {
					tag: 'path',
					attributes: {
						fill: 'currentColor',
						d: vectorData[ 0 ],
					},
				},
			};
		} else if ( iconName && prefix && !config.showMissingIcons ) {
			throw new MissingIcon( "Icon is missing for prefix ".concat( prefix, " with icon name " ).concat( iconName ) );
		}

		return val;
	}

	function generateSvgReplacementMutation( node, nodeMeta ) {
		var iconName = nodeMeta.iconName,
			title = nodeMeta.title,
			prefix = nodeMeta.prefix,
			transform = nodeMeta.transform,
			symbol = nodeMeta.symbol,
			mask = nodeMeta.mask,
			extra = nodeMeta.extra;
		return [node, makeInlineSvgAbstract( {
			icons: {
				main: findIcon( iconName, prefix ),
				mask: findIcon( mask.iconName, mask.prefix ),
			},
			prefix: prefix,
			iconName: iconName,
			transform: transform,
			symbol: symbol,
			mask: mask,
			title: title,
			extra: extra,
			watchable: true,
		} )];
	}

	function generateLayersText( node, nodeMeta ) {
		var title = nodeMeta.title,
			transform = nodeMeta.transform,
			extra = nodeMeta.extra;
		var width = null;
		var height = null;

		if ( IS_IE ) {
			var computedFontSize = parseInt( getComputedStyle( node ).fontSize, 10 );
			var boundingClientRect = node.getBoundingClientRect();
			width = boundingClientRect.width / computedFontSize;
			height = boundingClientRect.height / computedFontSize;
		}

		if ( config.autoA11y && !title ) {
			extra.attributes[ 'aria-hidden' ] = 'true';
		}

		return [node, makeLayersTextAbstract( {
			content: node.innerHTML,
			width: width,
			height: height,
			transform: transform,
			title: title,
			extra: extra,
			watchable: true,
		} )];
	}

	function generateMutation( node ) {
		var nodeMeta = parseMeta( node );

		if ( ~nodeMeta.extra.classes.indexOf( LAYERS_TEXT_CLASSNAME ) ) {
			return generateLayersText( node, nodeMeta );
		} else {
			return generateSvgReplacementMutation( node, nodeMeta );
		}
	}

	function searchPseudoElements( root ) {
		if ( !IS_DOM ) return;
		var end = perf.begin( 'searchPseudoElements' );
		disableObservation( function() {
			toArray( root.querySelectorAll( '*' ) ).filter( function( n ) {
				return n.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf( n.tagName.toUpperCase() ) && !n.getAttribute( DATA_FA_PSEUDO_ELEMENT ) && (!n.parentNode || n.parentNode.tagName !== 'svg');
			} ).forEach( function( node ) {
				[':before', ':after'].forEach( function( pos ) {
					var children = toArray( node.children );
					var alreadyProcessedPseudoElement = children.filter( function( c ) {
						return c.getAttribute( DATA_FA_PSEUDO_ELEMENT ) === pos;
					} )[ 0 ];
					var styles = WINDOW.getComputedStyle( node, pos );
					var fontFamily = styles.getPropertyValue( 'font-family' ).match( FONT_FAMILY_PATTERN );
					var fontWeight = styles.getPropertyValue( 'font-weight' );

					if ( alreadyProcessedPseudoElement && !fontFamily ) {
						// If we've already processed it but the current computed style does not result in a font-family,
						// that probably means that a class name that was previously present to make the icon has been
						// removed. So we now should delete the icon.
						node.removeChild( alreadyProcessedPseudoElement );
					} else if ( fontFamily ) {
						var content = styles.getPropertyValue( 'content' );
						var prefix = ~['Light', 'Regular', 'Solid', 'Brands'].indexOf( fontFamily[ 1 ] ) ? STYLE_TO_PREFIX[ fontFamily[ 1 ] ] : FONT_WEIGHT_TO_PREFIX[ fontWeight ];
						var iconName = byUnicode( prefix, toHex( content.length === 3 ? content.substr( 1, 1 ) : content ) ); // Only convert the pseudo element in this :before/:after position into an icon if we haven't
						// already done so with the same prefix and iconName

						if ( !alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute( DATA_PREFIX ) !== prefix || alreadyProcessedPseudoElement.getAttribute( DATA_ICON ) !== iconName ) {
							if ( alreadyProcessedPseudoElement ) {
								// Delete the old one, since we're replacing it with a new one
								node.removeChild( alreadyProcessedPseudoElement );
							}

							var extra = blankMeta.extra;
							extra.attributes[ DATA_FA_PSEUDO_ELEMENT ] = pos;
							var abstract = makeInlineSvgAbstract( _objectSpread( {}, blankMeta, {
								icons: {
									main: findIcon( iconName, prefix ),
									mask: emptyCanonicalIcon(),
								},
								prefix: prefix,
								iconName: iconName,
								extra: extra,
								watchable: true,
							} ) );
							var element = DOCUMENT.createElement( 'svg' );

							if ( pos === ':before' ) {
								node.insertBefore( element, node.firstChild );
							} else {
								node.appendChild( element );
							}

							element.outerHTML = abstract.map( function( a ) {
								return toHtml( a );
							} ).join( '\n' );
						}
					}
				} );
			} );
		} );
		end();
	}

	function onTree( root ) {
		var callback = arguments.length > 1 && arguments[ 1 ] !== undefined ? arguments[ 1 ] : null;
		if ( !IS_DOM ) return;
		var htmlClassList = DOCUMENT.documentElement.classList;

		var hclAdd = function hclAdd( suffix ) {
			return htmlClassList.add( "".concat( HTML_CLASS_I2SVG_BASE_CLASS, "-" ).concat( suffix ) );
		};

		var hclRemove = function hclRemove( suffix ) {
			return htmlClassList.remove( "".concat( HTML_CLASS_I2SVG_BASE_CLASS, "-" ).concat( suffix ) );
		};

		var prefixes = Object.keys( styles$2 );
		var prefixesDomQuery = [".".concat( LAYERS_TEXT_CLASSNAME, ":not([" ).concat( DATA_FA_I2SVG, "])" )].concat( prefixes.map( function( p ) {
			return ".".concat( p, ":not([" ).concat( DATA_FA_I2SVG, "])" );
		} ) ).join( ', ' );

		if ( prefixesDomQuery.length === 0 ) {
			return;
		}

		var candidates = toArray( root.querySelectorAll( prefixesDomQuery ) );

		if ( candidates.length > 0 ) {
			hclAdd( 'pending' );
			hclRemove( 'complete' );
		} else {
			return;
		}

		var mark = perf.begin( 'onTree' );
		var mutations = candidates.reduce( function( acc, node ) {
			try {
				var mutation = generateMutation( node );

				if ( mutation ) {
					acc.push( mutation );
				}
			} catch ( e ) {
				if ( !PRODUCTION ) {
					if ( e instanceof MissingIcon ) {
						console.error( e );
					}
				}
			}

			return acc;
		}, [] );
		mark();
		perform( mutations, function() {
			hclAdd( 'active' );
			hclAdd( 'complete' );
			hclRemove( 'pending' );
			if ( typeof callback === 'function' ) callback();
		} );
	}

	function onNode( node ) {
		var callback = arguments.length > 1 && arguments[ 1 ] !== undefined ? arguments[ 1 ] : null;
		var mutation = generateMutation( node );

		if ( mutation ) {
			perform( [mutation], callback );
		}
	}

	var baseStyles = "svg:not(:root).svg-inline--fa{overflow:visible}.svg-inline--fa{display:inline-block;font-size:inherit;height:1em;overflow:visible;vertical-align:-.125em}.svg-inline--fa.fa-lg{vertical-align:-.225em}.svg-inline--fa.fa-w-1{width:.0625em}.svg-inline--fa.fa-w-2{width:.125em}.svg-inline--fa.fa-w-3{width:.1875em}.svg-inline--fa.fa-w-4{width:.25em}.svg-inline--fa.fa-w-5{width:.3125em}.svg-inline--fa.fa-w-6{width:.375em}.svg-inline--fa.fa-w-7{width:.4375em}.svg-inline--fa.fa-w-8{width:.5em}.svg-inline--fa.fa-w-9{width:.5625em}.svg-inline--fa.fa-w-10{width:.625em}.svg-inline--fa.fa-w-11{width:.6875em}.svg-inline--fa.fa-w-12{width:.75em}.svg-inline--fa.fa-w-13{width:.8125em}.svg-inline--fa.fa-w-14{width:.875em}.svg-inline--fa.fa-w-15{width:.9375em}.svg-inline--fa.fa-w-16{width:1em}.svg-inline--fa.fa-w-17{width:1.0625em}.svg-inline--fa.fa-w-18{width:1.125em}.svg-inline--fa.fa-w-19{width:1.1875em}.svg-inline--fa.fa-w-20{width:1.25em}.svg-inline--fa.fa-pull-left{margin-right:.3em;width:auto}.svg-inline--fa.fa-pull-right{margin-left:.3em;width:auto}.svg-inline--fa.fa-border{height:1.5em}.svg-inline--fa.fa-li{width:2em}.svg-inline--fa.fa-fw{width:1.25em}.fa-layers svg.svg-inline--fa{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.fa-layers{display:inline-block;height:1em;position:relative;text-align:center;vertical-align:-.125em;width:1em}.fa-layers svg.svg-inline--fa{-webkit-transform-origin:center center;transform-origin:center center}.fa-layers-counter,.fa-layers-text{display:inline-block;position:absolute;text-align:center}.fa-layers-text{left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);-webkit-transform-origin:center center;transform-origin:center center}.fa-layers-counter{background-color:#ff253a;border-radius:1em;-webkit-box-sizing:border-box;box-sizing:border-box;color:#fff;height:1.5em;line-height:1;max-width:5em;min-width:1.5em;overflow:hidden;padding:.25em;right:0;text-overflow:ellipsis;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top right;transform-origin:top right}.fa-layers-bottom-right{bottom:0;right:0;top:auto;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:bottom right;transform-origin:bottom right}.fa-layers-bottom-left{bottom:0;left:0;right:auto;top:auto;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:bottom left;transform-origin:bottom left}.fa-layers-top-right{right:0;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top right;transform-origin:top right}.fa-layers-top-left{left:0;right:auto;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top left;transform-origin:top left}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-.0667em}.fa-xs{font-size:.75em}.fa-sm{font-size:.875em}.fa-1x{font-size:1em}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-6x{font-size:6em}.fa-7x{font-size:7em}.fa-8x{font-size:8em}.fa-9x{font-size:9em}.fa-10x{font-size:10em}.fa-fw{text-align:center;width:1.25em}.fa-ul{list-style-type:none;margin-left:2.5em;padding-left:0}.fa-ul>li{position:relative}.fa-li{left:-2em;position:absolute;text-align:center;width:2em;line-height:inherit}.fa-border{border:solid .08em #eee;border-radius:.1em;padding:.2em .25em .15em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left,.fab.fa-pull-left,.fal.fa-pull-left,.far.fa-pull-left,.fas.fa-pull-left{margin-right:.3em}.fa.fa-pull-right,.fab.fa-pull-right,.fal.fa-pull-right,.far.fa-pull-right,.fas.fa-pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.fa-rotate-90{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-webkit-transform:scale(-1,1);transform:scale(-1,1)}.fa-flip-vertical{-webkit-transform:scale(1,-1);transform:scale(1,-1)}.fa-flip-horizontal.fa-flip-vertical{-webkit-transform:scale(-1,-1);transform:scale(-1,-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-rotate-90{-webkit-filter:none;filter:none}.fa-stack{display:inline-block;height:2em;position:relative;width:2.5em}.fa-stack-1x,.fa-stack-2x{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.svg-inline--fa.fa-stack-1x{height:1em;width:1.25em}.svg-inline--fa.fa-stack-2x{height:2em;width:2.5em}.fa-inverse{color:#fff}.sr-only{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sr-only-focusable:active,.sr-only-focusable:focus{clip:auto;height:auto;margin:0;overflow:visible;position:static;width:auto}";

	function css() {
		var dfp = DEFAULT_FAMILY_PREFIX;
		var drc = DEFAULT_REPLACEMENT_CLASS;
		var fp = config.familyPrefix;
		var rc = config.replacementClass;
		var s = baseStyles;

		if ( fp !== dfp || rc !== drc ) {
			var dPatt = new RegExp( "\\.".concat( dfp, "\\-" ), 'g' );
			var rPatt = new RegExp( "\\.".concat( drc ), 'g' );
			s = s.replace( dPatt, ".".concat( fp, "-" ) ).replace( rPatt, ".".concat( rc ) );
		}

		return s;
	}

	function define( prefix, icons ) {
		var normalized = Object.keys( icons ).reduce( function( acc, iconName ) {
			var icon = icons[ iconName ];
			var expanded = !!icon.icon;

			if ( expanded ) {
				acc[ icon.iconName ] = icon.icon;
			} else {
				acc[ iconName ] = icon;
			}

			return acc;
		}, {} );

		if ( typeof namespace.hooks.addPack === 'function' ) {
			namespace.hooks.addPack( prefix, normalized );
		} else {
			namespace.styles[ prefix ] = _objectSpread( {}, namespace.styles[ prefix ] || {}, normalized );
		}
		/**
		 * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
		 * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
		 * for `fas` so we'll easy the upgrade process for our users by automatically defining
		 * this as well.
		 */


		if ( prefix === 'fas' ) {
			define( 'fa', icons );
		}
	}

	var Library =
		/*#__PURE__*/
		function() {
			function Library() {
				_classCallCheck( this, Library );

				this.definitions = {};
			}

			_createClass( Library, [{
				key: "add",
				value: function add() {
					var _this = this;

					for ( var _len = arguments.length, definitions = new Array( _len ), _key = 0; _key < _len; _key++ ) {
						definitions[ _key ] = arguments[ _key ];
					}

					var additions = definitions.reduce( this._pullDefinitions, {} );
					Object.keys( additions ).forEach( function( key ) {
						_this.definitions[ key ] = _objectSpread( {}, _this.definitions[ key ] || {}, additions[ key ] );
						define( key, additions[ key ] );
						build();
					} );
				},
			}, {
				key: "reset",
				value: function reset() {
					this.definitions = {};
				},
			}, {
				key: "_pullDefinitions",
				value: function _pullDefinitions( additions, definition ) {
					var normalized = definition.prefix && definition.iconName && definition.icon ? {
						0: definition,
					} : definition;
					Object.keys( normalized ).map( function( key ) {
						var _normalized$key = normalized[ key ],
							prefix = _normalized$key.prefix,
							iconName = _normalized$key.iconName,
							icon = _normalized$key.icon;
						if ( !additions[ prefix ] ) additions[ prefix ] = {};
						additions[ prefix ][ iconName ] = icon;
					} );
					return additions;
				},
			}] );

			return Library;
		}();

	function prepIcon( icon ) {
		var width = icon[ 0 ];
		var height = icon[ 1 ];
		var vectorData = icon.slice( 4 );
		return {
			found: true,
			width: width,
			height: height,
			icon: {
				tag: 'path',
				attributes: {
					fill: 'currentColor',
					d: vectorData[ 0 ],
				},
			},
		};
	}

	function ensureCss() {
		if ( config.autoAddCss && !_cssInserted ) {
			insertCss( css() );

			_cssInserted = true;
		}
	}

	function apiObject( val, abstractCreator ) {
		Object.defineProperty( val, 'abstract', {
			get: abstractCreator,
		} );
		Object.defineProperty( val, 'html', {
			get: function get() {
				return val.abstract.map( function( a ) {
					return toHtml( a );
				} );
			},
		} );
		Object.defineProperty( val, 'node', {
			get: function get() {
				if ( !IS_DOM ) return;
				var container = DOCUMENT.createElement( 'div' );
				container.innerHTML = val.html;
				return container.children;
			},
		} );
		return val;
	}

	function findIconDefinition( params ) {
		var _params$prefix = params.prefix,
			prefix = _params$prefix === void 0 ? 'fa' : _params$prefix,
			iconName = params.iconName;
		if ( !iconName ) return;
		return iconFromMapping( library.definitions, prefix, iconName ) || iconFromMapping( namespace.styles, prefix, iconName );
	}

	function resolveIcons( next ) {
		return function( maybeIconDefinition ) {
			var params = arguments.length > 1 && arguments[ 1 ] !== undefined ? arguments[ 1 ] : {};
			var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition( maybeIconDefinition || {} );
			var mask = params.mask;

			if ( mask ) {
				mask = (mask || {}).icon ? mask : findIconDefinition( mask || {} );
			}

			return next( iconDefinition, _objectSpread( {}, params, {
				mask: mask,
			} ) );
		};
	}

	var library = new Library();
	var noAuto = function noAuto() {
		config.autoReplaceSvg = false;
		config.observeMutations = false;
		disconnect();
	};
	var _cssInserted = false;
	var dom = {
		i2svg: function i2svg() {
			var params = arguments.length > 0 && arguments[ 0 ] !== undefined ? arguments[ 0 ] : {};

			if ( IS_DOM ) {
				ensureCss();
				var _params$node = params.node,
					node = _params$node === void 0 ? DOCUMENT : _params$node,
					_params$callback = params.callback,
					callback = _params$callback === void 0 ? function() {
					} : _params$callback;

				if ( config.searchPseudoElements ) {
					searchPseudoElements( node );
				}

				onTree( node, callback );
			}
		},
		css: css,
		insertCss: function insertCss$$1() {
			if ( !_cssInserted ) {
				insertCss( css() );

				_cssInserted = true;
			}
		},
		watch: function watch() {
			var params = arguments.length > 0 && arguments[ 0 ] !== undefined ? arguments[ 0 ] : {};
			var autoReplaceSvgRoot = params.autoReplaceSvgRoot,
				observeMutationsRoot = params.observeMutationsRoot;

			if ( config.autoReplaceSvg === false ) {
				config.autoReplaceSvg = true;
			}

			config.observeMutations = true;
			domready( function() {
				autoReplace( {
					autoReplaceSvgRoot: autoReplaceSvgRoot,
				} );
				observe( {
					treeCallback: onTree,
					nodeCallback: onNode,
					pseudoElementsCallback: searchPseudoElements,
					observeMutationsRoot: observeMutationsRoot,
				} );
			} );
		},
	};
	var parse = {
		transform: function transform( transformString ) {
			return parseTransformString( transformString );
		},
	};
	var icon = resolveIcons( function( iconDefinition ) {
		var params = arguments.length > 1 && arguments[ 1 ] !== undefined ? arguments[ 1 ] : {};
		var _params$transform = params.transform,
			transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
			_params$symbol = params.symbol,
			symbol = _params$symbol === void 0 ? false : _params$symbol,
			_params$mask = params.mask,
			mask = _params$mask === void 0 ? null : _params$mask,
			_params$title = params.title,
			title = _params$title === void 0 ? null : _params$title,
			_params$classes = params.classes,
			classes = _params$classes === void 0 ? [] : _params$classes,
			_params$attributes = params.attributes,
			attributes = _params$attributes === void 0 ? {} : _params$attributes,
			_params$styles = params.styles,
			styles = _params$styles === void 0 ? {} : _params$styles;
		if ( !iconDefinition ) return;
		var prefix = iconDefinition.prefix,
			iconName = iconDefinition.iconName,
			icon = iconDefinition.icon;
		return apiObject( _objectSpread( {
			type: 'icon',
		}, iconDefinition ), function() {
			ensureCss();

			if ( config.autoA11y ) {
				if ( title ) {
					attributes[ 'aria-labelledby' ] = "".concat( config.replacementClass, "-title-" ).concat( nextUniqueId() );
				} else {
					attributes[ 'aria-hidden' ] = 'true';
				}
			}

			return makeInlineSvgAbstract( {
				icons: {
					main: prepIcon( icon ),
					mask: mask ? prepIcon( mask.icon ) : {
						found: false,
						width: null,
						height: null,
						icon: {},
					},
				},
				prefix: prefix,
				iconName: iconName,
				transform: _objectSpread( {}, meaninglessTransform, transform ),
				symbol: symbol,
				title: title,
				extra: {
					attributes: attributes,
					styles: styles,
					classes: classes,
				},
			} );
		} );
	} );
	var text = function text( content ) {
		var params = arguments.length > 1 && arguments[ 1 ] !== undefined ? arguments[ 1 ] : {};
		var _params$transform2 = params.transform,
			transform = _params$transform2 === void 0 ? meaninglessTransform : _params$transform2,
			_params$title2 = params.title,
			title = _params$title2 === void 0 ? null : _params$title2,
			_params$classes2 = params.classes,
			classes = _params$classes2 === void 0 ? [] : _params$classes2,
			_params$attributes2 = params.attributes,
			attributes = _params$attributes2 === void 0 ? {} : _params$attributes2,
			_params$styles2 = params.styles,
			styles = _params$styles2 === void 0 ? {} : _params$styles2;
		return apiObject( {
			type: 'text',
			content: content,
		}, function() {
			ensureCss();
			return makeLayersTextAbstract( {
				content: content,
				transform: _objectSpread( {}, meaninglessTransform, transform ),
				title: title,
				extra: {
					attributes: attributes,
					styles: styles,
					classes: ["".concat( config.familyPrefix, "-layers-text" )].concat( _toConsumableArray( classes ) ),
				},
			} );
		} );
	};
	var counter = function counter( content ) {
		var params = arguments.length > 1 && arguments[ 1 ] !== undefined ? arguments[ 1 ] : {};
		var _params$title3 = params.title,
			title = _params$title3 === void 0 ? null : _params$title3,
			_params$classes3 = params.classes,
			classes = _params$classes3 === void 0 ? [] : _params$classes3,
			_params$attributes3 = params.attributes,
			attributes = _params$attributes3 === void 0 ? {} : _params$attributes3,
			_params$styles3 = params.styles,
			styles = _params$styles3 === void 0 ? {} : _params$styles3;
		return apiObject( {
			type: 'counter',
			content: content,
		}, function() {
			ensureCss();
			return makeLayersCounterAbstract( {
				content: content.toString(),
				title: title,
				extra: {
					attributes: attributes,
					styles: styles,
					classes: ["".concat( config.familyPrefix, "-layers-counter" )].concat( _toConsumableArray( classes ) ),
				},
			} );
		} );
	};
	var layer = function layer( assembler ) {
		return apiObject( {
			type: 'layer',
		}, function() {
			ensureCss();
			var children = [];
			assembler( function( args ) {
				Array.isArray( args ) ? args.map( function( a ) {
					children = children.concat( a.abstract );
				} ) : children = children.concat( args.abstract );
			} );
			return [{
				tag: 'span',
				attributes: {
					class: "".concat( config.familyPrefix, "-layers" ),
				},
				children: children,
			}];
		} );
	};
	var api = {
		noAuto: noAuto,
		config: config,
		dom: dom,
		library: library,
		parse: parse,
		findIconDefinition: findIconDefinition,
		icon: icon,
		text: text,
		counter: counter,
		layer: layer,
		toHtml: toHtml,
	};

	var autoReplace = function autoReplace() {
		var params = arguments.length > 0 && arguments[ 0 ] !== undefined ? arguments[ 0 ] : {};
		var _params$autoReplaceSv = params.autoReplaceSvgRoot,
			autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
		if ( Object.keys( namespace.styles ).length > 0 && IS_DOM && config.autoReplaceSvg ) api.dom.i2svg( {
			node: autoReplaceSvgRoot,
		} );
	};

	function bootstrap() {
		if ( IS_BROWSER ) {
			if ( !WINDOW.FontAwesome ) {
				WINDOW.FontAwesome = api;
			}

			domready( function() {
				autoReplace();
				observe( {
					treeCallback: onTree,
					nodeCallback: onNode,
					pseudoElementsCallback: searchPseudoElements,
				} );
			} );
		}

		namespace.hooks = _objectSpread( {}, namespace.hooks, {
			addPack: function addPack( prefix, icons ) {
				namespace.styles[ prefix ] = _objectSpread( {}, namespace.styles[ prefix ] || {}, icons );
				build();
				autoReplace();
			},
			addShims: function addShims( shims ) {
				var _namespace$shims;

				(_namespace$shims = namespace.shims).push.apply( _namespace$shims, _toConsumableArray( shims ) );

				build();
				autoReplace();
			},
		} );
	}

	bunker( bootstrap );

}());
